var _defs, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _polygon8, _polygon9, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _polygon10, _polygon11, _path85, _path86, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _polygon17, _polygon18, _path94, _path95, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _polygon24, _polygon25, _path103, _path104, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _path105, _polygon57, _path106, _polygon58, _polygon59, _polygon60, _path107, _path108, _path109, _path110, _path111, _path112, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _polygon67, _polygon68, _path132, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _path133, _path134, _polygon75, _polygon76, _path135, _path136, _polygon77, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _polygon78, _polygon79, _polygon80, _polygon81, _path159, _path160, _path161, _path162, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _polygon92, _polygon93, _polygon94, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _path189, _path190, _polygon109, _polygon110, _polygon111, _polygon112, _path191, _path192, _polygon113, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _polygon114, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _rect, _polygon123, _rect2, _polygon124, _rect3, _path223, _path224, _polygon125, _path225, _path226, _polygon126, _path227, _path228, _polygon127, _path229, _path230, _polygon128, _path231, _path232, _polygon129, _path233, _ellipse, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _ellipse2, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _ellipse3, _ellipse4, _polygon130, _polygon131, _polygon132, _path252, _path253, _path254, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _path255, _path256, _path257, _path258, _polygon140, _polygon141, _polygon142, _polygon143, _path259, _path260, _path261, _polygon144, _path262, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _path263, _path264, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _path265, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _ellipse5, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _path361, _path362, _path363, _path364, _path365, _path366, _polygon177, _polygon178, _polygon179, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _polygon180, _rect4, _rect5, _rect6, _rect7, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _polygon192;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Page(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 393.36 316.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9c251f;}.cls-2{fill:#e31b25;}.cls-3{fill:#909090;}.cls-4,.cls-85,.cls-86{fill:#fff;}.cls-5{fill:#b9b9b9;}.cls-6{fill:#ff3f4a;}.cls-7{fill:#0a0a0a;}.cls-8{fill:#1b1b1b;}.cls-9{fill:#303030;}.cls-10,.cls-103{fill:#0d0d0d;}.cls-11{fill:#ff8400;}.cls-12{fill:#d9d9d9;}.cls-13{fill:#b5b5b5;}.cls-14{fill:#f0c6b4;}.cls-15{fill:#c7a495;}.cls-16{fill:#ff9d26;}.cls-17{fill:#262626;}.cls-18{fill:#474747;}.cls-19{fill:#212121;}.cls-20{fill:#939598;}.cls-21{fill:#333;}.cls-22{fill:#3b3b3b;}.cls-23{fill:#787878;}.cls-24{fill:#bcbec0;}.cls-25{fill:#b2b2b2;}.cls-26{fill:#999;}.cls-27{fill:gray;}.cls-28{fill:#727272;}.cls-29{fill:#0f2034;}.cls-30{fill:#603913;}.cls-31{fill:#2d6edf;opacity:0.6;}.cls-32{fill:#8c2300;}.cls-33{fill:#6d1600;}.cls-34{fill:#2e2e2e;}.cls-35{fill:#ff5b00;}.cls-36{fill:#242424;}.cls-37{fill:#1c1c1c;}.cls-38{fill:#3d3d3d;}.cls-39{fill:#575757;}.cls-40{fill:#dedede;}.cls-41{fill:#050505;}.cls-42{fill:#181818;}.cls-43{fill:#ebebeb;}.cls-44{fill:#134ba9;}.cls-45{fill:#2168df;}.cls-46{fill:#0a3c8c;}.cls-47{fill:#141414;}.cls-48{fill:#282828;}.cls-49{fill:#ebb554;}.cls-50{fill:#ffd567;}.cls-51{fill:#ae8437;}.cls-52{fill:#8c6829;}.cls-53{fill:#a88136;}.cls-54{fill:#77571f;}.cls-55{fill:#ae0404;}.cls-56{fill:#006190;}.cls-57{fill:#ff1818;}.cls-58{fill:#0b8dcb;}.cls-59{fill:#6d6325;}.cls-60{fill:#b3a447;}.cls-61{fill:#928537;}.cls-62{fill:#d5c359;}.cls-63{fill:#111;}.cls-64{fill:#0b0b0b;}.cls-65{fill:#4c4c4c;}.cls-66{fill:#373737;}.cls-67{fill:#a0a0a0;}.cls-68{fill:#7a7a7a;}.cls-69{fill:#1d1d1d;}.cls-70{fill:#2a2a2a;}.cls-71{fill:#444;}.cls-72{fill:#9c9c9c;}.cls-73{fill:#cbcbcb;}.cls-74{fill:#515151;}.cls-75{fill:#636363;}.cls-76{fill:#898989;}.cls-77{fill:#c9c9c9;}.cls-78{fill:#010101;}.cls-79{fill:#66959d;opacity:0.4;}.cls-80{fill:#232323;}.cls-81{fill:#070707;}.cls-82{fill:#4a4a4a;}.cls-83{fill:#e0d5ac;}.cls-84{fill:#00215c;}.cls-85{opacity:0.2;}.cls-86{opacity:0.1;}.cls-87{fill:#202020;}.cls-88{fill:#3e3e3e;}.cls-89{fill:#161616;}.cls-90{fill:#080808;}.cls-91{fill:#6e6e6e;}.cls-92{fill:#414141;}.cls-93{fill:#5c5c5c;}.cls-94{fill:#616161;}.cls-95{fill:#4f4f4f;}.cls-96{fill:#454545;}.cls-97{fill:#808285;}.cls-98{fill:#917441;}.cls-99{fill:#404040;}.cls-100{fill:#1a1a1a;}.cls-101{fill:#858585;}.cls-102{fill:#ba6000;}.cls-103{opacity:0.3;}.cls-104{fill:#f5f5f5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.41,179.17l-1.83-1.06h0a1.69,1.69,0,0,1-.77-1.56,5.41,5.41,0,0,1,2.32-4.32,1.72,1.72,0,0,1,1.72-.23l1.84,1.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368,173.29a5.41,5.41,0,0,0-2.32,4.32c.05,1.56,1.17,2.16,2.5,1.33a5.39,5.39,0,0,0,2.31-4.32C370.4,173.06,369.29,172.46,368,173.29Z",
    transform: "translate(-29.74 -23.35)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368,174.82a2.49,2.49,0,0,0-1.07,2c0,.72.54,1,1.15.61a2.46,2.46,0,0,0,1.06-2C369.13,174.72,368.62,174.44,368,174.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "335.95 127.76 349.03 135.31 349.03 162.97 335.95 155.42 335.95 127.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.37 146.68 338.37 151 345.63 155.19 345.63 153.55 339.8 150.18 339.8 147.5 338.37 146.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "339.8 147.5 339.8 150.18 345.63 153.55 345.63 150.87 339.8 147.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.37 135.31 338.37 144.87 345.63 149.07 345.63 147.42 339.8 144.05 339.8 136.14 338.37 135.31"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "339.8 136.14 339.8 144.05 345.63 147.42 345.63 139.51 339.8 136.14"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "335.95 127.76 349.03 135.31 354.73 132.02 341.66 124.47 335.95 127.76"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "349.03 135.31 354.73 132.02 360.36 142.84 360.36 156.42 349.03 162.97 349.03 135.31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.15,153.39l.06,2.14h0a1.08,1.08,0,0,1-.61.91,3.36,3.36,0,0,1-3.07.09,1.06,1.06,0,0,1-.67-.86l-.05-2.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.47,154.4a3.42,3.42,0,0,0,3.07-.1.94.94,0,0,0-.05-1.78,3.44,3.44,0,0,0-3.08.1A.94.94,0,0,0,377.47,154.4Z",
    transform: "translate(-29.74 -23.35)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.37,187.81l-1.83-1.06h0a1.71,1.71,0,0,1-.77-1.56,5.41,5.41,0,0,1,2.32-4.32,1.72,1.72,0,0,1,1.72-.23l1.84,1.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.92,181.93a5.4,5.4,0,0,0-2.31,4.32c.05,1.56,1.16,2.16,2.49,1.33a5.42,5.42,0,0,0,2.32-4.31C385.36,181.7,384.25,181.11,382.92,181.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383,183.46a2.47,2.47,0,0,0-1.06,2c0,.72.53,1,1.14.62a2.47,2.47,0,0,0,1.06-2C384.09,183.36,383.58,183.08,383,183.46Z",
    transform: "translate(-29.74 -23.35)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M345.55,170.32c-1.69,2.36-6.4,2.53-8.2,4.78-.57.64-.59,2.54.39,3,2.93.71,7.82-1.82,7.82-1.82s5.64-.32,6.24-1.25c.77-1.18.56-4.24.56-4.24S346,169.68,345.55,170.32Z",
    transform: "translate(-29.74 -23.35)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.35,129.06c-.73,10.52,2,20.32,2.41,22.66,1,8.26.12,16.3.05,18.48-.05,1.81,7.88,3.69,8.65.48.54-3.6.52-13.44-.83-18.62-.53-2,2.13-17.94,2.13-17.94S342.56,127,342.35,129.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.3,181.86c.11,1.16-2.32,5.85-1.46,7.25.78,1.25,3.59.75,5.14-.45s2.09-4.36,2.09-6.4c0-1.44-.14-2.94-.14-2.94l-5.58.45A8.79,8.79,0,0,0,360.3,181.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.91,123.63s8.12,6.11,11.36,5.94a9.23,9.23,0,0,0,6.42-3.44,33.48,33.48,0,0,1,2.62,5.6c.6,2.14.33,22,1.39,24.83s1.57,3.39,2.08,5.53.65,14.57.31,18-7.14,3.25-7.92.72c.23-8.9-.05-17.79-1.64-20.77-2.23-4.18-5.62-19.82-5.84-20.44-4.54-2.34-9.46-7.35-9.46-8.21A65.68,65.68,0,0,1,342.91,123.63Z",
    transform: "translate(-29.74 -23.35)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M330.26,126.86c.88-2.15-2-2.46-3.09-2.18-.79.21-2.62,4.52-2.76,5-.73,2-.74,3.3.22,4,1.45,1.58,5,.5,5.8-1.55.44-1.48-1.23-.67-1.23-.67C329.6,130.47,330.6,127.64,330.26,126.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M379,154.17c.61,0,1.11-.24,1.11-.85,0-6.09-12-9.29-20.07-10-1.55-.15-3.22-.24-5-.32-10.65-.53-18.8-1.57-18.8-9.45a1.12,1.12,0,0,0-2.24,0c0,10.63,11.61,11.21,20.93,11.68,1.74.09,3.39.17,4.89.31,8.54.81,18.05,4.13,18.05,7.83C377.86,153.93,378.36,154.17,379,154.17Z",
    transform: "translate(-29.74 -23.35)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M321.57,135.56a1.35,1.35,0,0,0,.67-.18l5.8-3.32c1.19-.68,2.86-1.38,4.06-.83a3.79,3.79,0,0,1,1.69,2.51,1.34,1.34,0,0,0,2.64-.46c0-.13-.59-3.26-3.18-4.47-1.81-.85-4-.54-6.55.93l-5.8,3.32a1.34,1.34,0,0,0-.49,1.83A1.36,1.36,0,0,0,321.57,135.56Z",
    transform: "translate(-29.74 -23.35)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.66,140.33l10-5.47h0a1,1,0,0,0,.45-.93,3.19,3.19,0,0,0-1.37-2.56,1,1,0,0,0-1-.14l-10,5.48Z",
    transform: "translate(-29.74 -23.35)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.74,136.85a3.19,3.19,0,0,1,1.37,2.56c0,.92-.69,1.27-1.47.79a3.25,3.25,0,0,1-1.38-2.56C312.29,136.71,313,136.36,313.74,136.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.7,137.39a2.14,2.14,0,0,1,.93,1.73c0,.63-.46.87-1,.53a2.2,2.2,0,0,1-.93-1.73C312.72,137.3,313.17,137.06,313.7,137.39Z",
    transform: "translate(-29.74 -23.35)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.94,168.33a2.8,2.8,0,1,0,2.8-2.79A2.8,2.8,0,0,0,289.94,168.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M313,137.33s-23.12,6.49-43.68,2c18.88,6.82-1.56,31.28,22.64,31.83,3.92-18.11,22.42-31.44,22.42-31.44s.82-.19.05-1.58S313,137.33,313,137.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.56,140.64c-2.2.16-4.5.26-6.86.28-3.91,11.65,14.32-.28,9.92,20.29a54.05,54.05,0,0,1,4.4-7C302.57,141.47,286.48,150.55,292.56,140.64Z",
    transform: "translate(-29.74 -23.35)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.24,138.23c-2.16.47-5.15,1.05-8.7,1.55-1.33,5,9.1-.46,4.08,8.87a78,78,0,0,1,6.18-6C312.93,140.76,304.5,140.64,309.24,138.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.93,137.47a1.51,1.51,0,1,1,1.51-1.51A1.52,1.52,0,0,1,276.93,137.47Z",
    transform: "translate(-29.74 -23.35)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.26,151.5a4.88,4.88,0,0,0,4.21,4.83,2.56,2.56,0,0,0-.58,1.64,2.6,2.6,0,0,0,2.2,2.57,4.74,4.74,0,0,0-.35,1.81,4.66,4.66,0,0,0,3.76,4.57,3.87,3.87,0,1,0,6.57,3.87l.33.13a2.73,2.73,0,0,0-.07.64,3,3,0,0,1,.19,1.56,3,3,0,0,0,5.12,2.11.86.86,0,0,0,.13.14,3.87,3.87,0,0,0-.27,1.4,3.72,3.72,0,0,0,7.35.85h.1a4.58,4.58,0,0,0,0-9.16,4.51,4.51,0,0,0-2,.49,3.91,3.91,0,0,0,0-.49,4.42,4.42,0,0,0-4.42-4.42,4.23,4.23,0,0,0-.63.05,4,4,0,0,0,.25-1.38,4.05,4.05,0,0,0-4.05-4.05H280a3.45,3.45,0,0,0,.14-1,3.55,3.55,0,0,0-.66-2.05,4.19,4.19,0,0,0-1-7.4,1.64,1.64,0,0,0,0-.23,2.39,2.39,0,0,0-.69-1.68,2.35,2.35,0,0,0,.69-1.67,2.39,2.39,0,0,0-1.92-2.35,4.51,4.51,0,0,0-2.54-3.64,3,3,0,0,0,.22-1.12,3.1,3.1,0,1,0-6.19,0v0a2.67,2.67,0,0,0-2.11,1.77,3.17,3.17,0,0,0-.86,6.15,3.32,3.32,0,0,0-.67,2A4.91,4.91,0,0,0,262.26,151.5Zm11.5-4.61.22-.1a1.28,1.28,0,0,0-.11.2Zm-4.06,8.77.07,0v.08Z",
    transform: "translate(-29.74 -23.35)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.59,161.69a1.18,1.18,0,1,1-1.18,1.18A1.17,1.17,0,0,1,264.59,161.69Z",
    transform: "translate(-29.74 -23.35)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.06,147.23a1.63,1.63,0,1,1-1.61,1.63A1.62,1.62,0,0,1,260.06,147.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.29,142.26a2.78,2.78,0,1,1-2.78,2.78A2.77,2.77,0,0,1,257.29,142.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.53,178.23a2,2,0,1,1-2,2A2,2,0,0,1,279.53,178.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.33,182.67a1,1,0,1,1-1,1A1,1,0,0,1,287.33,182.67Z",
    transform: "translate(-29.74 -23.35)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.31,178.54a2.35,2.35,0,1,1-2.35,2.35A2.35,2.35,0,0,1,296.31,178.54Z",
    transform: "translate(-29.74 -23.35)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.59,135.11a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,263.59,135.11Z",
    transform: "translate(-29.74 -23.35)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M338,113.19c-4,2.75-7,8.42-10.84,11.49a3.56,3.56,0,0,1,3.09,2.18c2.73-1.47,9.25-4.56,12.14-10.14,6.11-10.06,2.47-4.54.13-7.23a18.79,18.79,0,0,1-2.9-.74A46.46,46.46,0,0,0,338,113.19Z",
    transform: "translate(-29.74 -23.35)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M348.83,93.91c7,3.5-2.56,17.45-2.65,18.55-1,1.91-7.79-.28-7.53-2.68,1.64-4.69,1.87-5.23,3.63-9.67C344.47,95.14,346.5,92.84,348.83,93.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M359,92.09a10.22,10.22,0,0,0,1.38,5.11l-2.59,2.37L355.34,101h-2.82l-2-1.69,1.8-5.55,3.27-2.5S359,91.36,359,92.09Z",
    transform: "translate(-29.74 -23.35)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M352.1,97.69a1.63,1.63,0,0,0,.75,2.43c2.31,1.49,7.32-3.31,7.32-3.31l1.55,1,.65,1.58,1.77,1,1.41,1.3s-3.06,14.35-3,15.54-3.54,4.06-1.87,8.9c.55,1-2.67,5.11-7.55,4.52.4-2.06-1.63-2.85-2.84-3.51a26.2,26.2,0,0,0-6.76-2.44s-1.2-16.7-1.2-19.94c0-5.57,7.67-10,7.67-10Z",
    transform: "translate(-29.74 -23.35)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.18,92.82a17.82,17.82,0,0,0-10.65,10.92l2.23,1.54a14.56,14.56,0,0,1,10.58-10.53C356.34,94.18,354.83,93,354.18,92.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M355.26,130.83c-2.76-7.32.37-20.73.37-20.73s-8.51-3.48-12.51-7.74a85.71,85.71,0,0,0-.21,21.27l1.67,2.81,5,4.26S356,133.24,355.26,130.83Z",
    transform: "translate(-29.74 -23.35)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M361.72,97.85c-9,4.05-9.92,11.59-9.92,11.59l2.77,1.09s.07-7.82,9.57-10.14A5.63,5.63,0,0,0,361.72,97.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M349.36,83.71a7,7,0,0,0-2.18,7.23s.87,6.77,1.46,7.42a4.09,4.09,0,0,0,2.15,1c1.18.11,5.22-2.65,5.81-3.38a3.53,3.53,0,0,0,.48-2.13s1.92-.15,2.22-2.79a9.56,9.56,0,0,0-.09-3l-1.52-3.33-3.23-2h-2.63A14.36,14.36,0,0,0,349.36,83.71Z",
    transform: "translate(-29.74 -23.35)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M359.14,91.91s.16-3.18-1.47-1.79c-.53.55-.32.88-.71,1.53s-1.38,1-1.62.77a9.52,9.52,0,0,1-.23-4.06c.3-.94,1.91-1.68.79-2.93s-5.4,2.38-6.84,1c-1-1.06,1.53-8.56,8.68-4.17C362.82,85.61,359.14,91.91,359.14,91.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M356.93,146.8c.15.83,2.61.7,3.72.67.82,0,1.16-.07,2.21-1.36s.79-3.37,1.52-5.9c.54-1.09-2.11-2.14-3.67-1.34-.87,1.12-3.51,2.44-3.77,5.4A10.11,10.11,0,0,0,356.93,146.8Z",
    transform: "translate(-29.74 -23.35)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M363.39,125.26c-2.21,4.26-1.62,11-2.68,13.61a4.31,4.31,0,0,1,3.67,1.34c1.3-3.82,5.25-9.37,5.21-14.79a42,42,0,0,0,.08-6c-.18-3-1.38.79-3.91,0-1,.45-1.8-.63-2.19.52C363.32,120.71,363.64,122.67,363.39,125.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M364.54,101.41c6.4.74,5.41,17.7,5.69,18.77-.28,2.13-7.22,2.31-7.78,0-.6-4.39-.67-7-1.64-10.87C359.67,104.62,363.25,101.25,364.54,101.41Z",
    transform: "translate(-29.74 -23.35)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M324.73,130.76c.23.51,1.27.53,2.32.05s1.72-1.27,1.49-1.78-1.26-.52-2.32,0S324.5,130.26,324.73,130.76Z",
    transform: "translate(-29.74 -23.35)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M113.83,78.47a10.69,10.69,0,0,0,.72,2.09c2.57.37,8.93,5,10.52,5.26s1.11,4.32-1,4.15c-5.35-1.73-10.12-2-12.92-4.61a25.1,25.1,0,0,1-2.42-3.9Z",
    transform: "translate(-29.74 -23.35)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.94,61.59a10.88,10.88,0,0,1-1.6,3.94l2.83,3.67,2.49,1.47h2.86l2-1.72-1.83-5.64L98.4,60.76S94.94,60.86,94.94,61.59Z",
    transform: "translate(-29.74 -23.35)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M105.11,63c-7.65,1.25,3.22,18,2.94,19.07.28,2.17,5.93-1.31,6.5-3.7a23.36,23.36,0,0,1-2.75-6.7C111,67.12,109.13,62.57,105.11,63Z",
    transform: "translate(-29.74 -23.35)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M101.3,64.85s1.22,2.68-.55,3.67c-2.34,1.51-7.41-3-7.41-3L92,66.82l-.53,1.59-2.12.87-1.18,1.06s2,13.78,1.87,15,3.6,4.13,1.9,9c-.55,1,2.72,5.2,7.67,4.59-.39-2.09,1.67-2.89,2.9-3.56a26.49,26.49,0,0,1,6.87-2.49S111,77.35,110.9,73.36c-.17-6.13-8.11-10.89-8.11-10.89Z",
    transform: "translate(-29.74 -23.35)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.7,60.7a18.12,18.12,0,0,1,10.82,11.1l-2.26,1.56A14.79,14.79,0,0,0,96.5,62.67C96.5,62.08,98,60.87,98.7,60.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.59,98.28c2.81-7.43-.37-19.73-.37-19.73s8.66-3.07,12.72-7.4c1.64,11.17.1,16.11.22,19.82s-1.7,2.85-1.7,2.85l-5.06,4.34S96.84,100.74,97.59,98.28Z",
    transform: "translate(-29.74 -23.35)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92,66.82c8.7,3.44,9.52,10.83,9.52,10.83l-2.81,1.1s-1.49-8-9.36-9.47C89.34,68.7,91.32,67,92,66.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112.68,146.13c1.72,2.4,6.87,2.53,8.38,4.51.58.66.71,2.41-.29,2.87-3,.72-7.6-1.36-7.6-1.36s-5.64.21-6.25-.73c-.78-1.2-.51-5.06-.51-5.06S112.23,145.48,112.68,146.13Z",
    transform: "translate(-29.74 -23.35)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.9,99.14c1.81,9.22.85,23.62.88,26.12-.06,6,2,18.36,2,20.58,0,1.84-7.25,3.27-8,0-.83-2.26-2.34-10.58-1.89-19.59-.4-4-4.09-19.06-4.09-19.06S110.79,96.87,110.9,99.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.61,144.53c.43,1.1,3.43,6.23,2.47,7.81-.79,1.28-3.72,1-5.29-.2s-2.8-4.62-2.8-6.69c0-1.47-.14-3.27-.14-3.27h6A10.94,10.94,0,0,0,87.61,144.53Z",
    transform: "translate(-29.74 -23.35)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.16,91s-9.33,7-12.62,6.78a6.6,6.6,0,0,1-5.61-3.38,38.54,38.54,0,0,0-2.61,5.85c-.61,2.18-4.43,20-5.51,22.83-4.14,4.88-3.38,15.83-3,19.3s7.58,2.9,7.75.63a57.07,57.07,0,0,1,1.76-15.69c3.24-4.7,9.66-18.72,9.88-19.35,4.61-2.38,10.74-7.92,10.74-8.8A75.21,75.21,0,0,0,110.16,91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.6,52.81a7.18,7.18,0,0,1,2.22,7.35s-.89,6.88-1.49,7.54a4.1,4.1,0,0,1-2.18,1.06c-1.2.11-5.32-2.69-5.92-3.44a3.61,3.61,0,0,1-.48-2.16s-2-.15-2.26-2.83a9.55,9.55,0,0,1,.09-3l1.55-3.38,3.28-2h2.68A15.05,15.05,0,0,1,104.6,52.81Z",
    transform: "translate(-29.74 -23.35)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.66,61.14s-.17-3.22,1.49-1.82c.54.57.32.9.73,1.56s1.39,1,1.64.79a9.86,9.86,0,0,0,.23-4.13c-.3-.95-1.94-1.71-.8-3s5.49,2.43,7,1c1-1.08-1.55-8.7-8.83-4.24C90.91,54.74,94.66,61.14,94.66,61.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.33,92.42c3-.13,6.77,3,10.25,4.4a4.3,4.3,0,0,0-1.11,3.22c-3.67-.71-12.8-1.24-14.59-3.8-.65-1.51-.91-4.51-.85-8.13,1.21-1.3,5.37-.51,6.64.58C93,89,92.24,92.43,92.33,92.42Z",
    transform: "translate(-29.74 -23.35)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M88.39,70.3c-7.65,1.25-3.12,18.92-3.4,20,.28,2.17,7.45,2.24,8-.16.6-4.47-1-8.12-.3-10.69C93.34,75.69,89.7,70.13,88.39,70.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.56,82.61l3.66-2.12a1.09,1.09,0,0,0,.46-1,3.47,3.47,0,0,0-1.56-2.7,1.1,1.1,0,0,0-1.1-.11l-3.66,2.11Z",
    transform: "translate(-29.74 -23.35)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M126.46,78.9A3.44,3.44,0,0,1,128,81.6c0,1-.7,1.39-1.56.9a3.46,3.46,0,0,1-1.56-2.7C124.9,78.81,125.6,78.4,126.46,78.9Z",
    transform: "translate(-29.74 -23.35)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M120.12,90l8.7-5a2.41,2.41,0,0,0,1-2.23,7.62,7.62,0,0,0-3.46-6,2.41,2.41,0,0,0-2.43-.24l-8.71,5Z",
    transform: "translate(-29.74 -23.35)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M117.69,81.78a7.65,7.65,0,0,1,3.45,6c0,2.2-1.55,3.09-3.45,2a7.6,7.6,0,0,1-3.45-6C114.24,81.57,115.78,80.68,117.69,81.78Z",
    transform: "translate(-29.74 -23.35)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.13,92l1.66-1a3.3,3.3,0,0,0,1.37-3,10.39,10.39,0,0,0-4.69-8.14,3.3,3.3,0,0,0-3.32-.33l-1.66,1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.81,80.85a10.4,10.4,0,0,1,4.7,8.13c0,3-2.11,4.21-4.7,2.72a10.39,10.39,0,0,1-4.7-8.14C112.11,80.57,114.21,79.35,116.81,80.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.89,93.32l1.66-1a3.31,3.31,0,0,0,1.38-3,10.37,10.37,0,0,0-4.7-8.14,3.3,3.3,0,0,0-3.32-.33l-1.66,1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M114.57,82.14a10.37,10.37,0,0,1,4.7,8.13c0,3-2.1,4.21-4.7,2.71a10.33,10.33,0,0,1-4.69-8.13C109.87,81.86,112,80.64,114.57,82.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.32,95.38l3-1.71a3.3,3.3,0,0,0,1.38-3,10.37,10.37,0,0,0-4.7-8.14,3.3,3.3,0,0,0-3.32-.33l-3,1.71Z",
    transform: "translate(-29.74 -23.35)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M111,84.2a10.37,10.37,0,0,1,4.7,8.14c0,3-2.1,4.21-4.7,2.71a10.39,10.39,0,0,1-4.69-8.14C106.31,83.91,108.41,82.7,111,84.2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.52,101.47l13.59-7.85a2.23,2.23,0,0,0,.94-2.06,7.06,7.06,0,0,0-3.2-5.54,2.26,2.26,0,0,0-2.26-.23L95,93.64Z",
    transform: "translate(-29.74 -23.35)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.26,93.87a7.08,7.08,0,0,1,3.19,5.53c0,2-1.43,2.87-3.19,1.85a7.06,7.06,0,0,1-3.2-5.54C94.06,93.67,95.49,92.85,97.26,93.87Z",
    transform: "translate(-29.74 -23.35)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.93,100.29l1.25-.72a1.12,1.12,0,0,0,.46-1,3.45,3.45,0,0,0-1.56-2.69A1.09,1.09,0,0,0,96,95.76l-1.24.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M95.83,96.59a3.43,3.43,0,0,1,1.56,2.69c0,1-.7,1.4-1.56.9a3.44,3.44,0,0,1-1.56-2.7C94.27,96.49,95,96.09,95.83,96.59Z",
    transform: "translate(-29.74 -23.35)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.92,101l3.18-1.83a.38.38,0,0,0,.16-.35,1.2,1.2,0,0,0-.55-.94.36.36,0,0,0-.38,0l-3.18,1.83Z",
    transform: "translate(-29.74 -23.35)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M92.54,99.66a1.19,1.19,0,0,1,.54.94c0,.34-.24.48-.54.31A1.19,1.19,0,0,1,92,100C92,99.63,92.24,99.48,92.54,99.66Z",
    transform: "translate(-29.74 -23.35)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M123.34,90c-.44-.22-.53-1.65-.3-2.35s1.9-2.36,3-2.12a2,2,0,0,1,1.77,2.12c0,1-.88,1.72-2,2.45A2.51,2.51,0,0,1,123.34,90Z",
    transform: "translate(-29.74 -23.35)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M102.79,99.58a2.81,2.81,0,0,1,.13-2.71c.5-.73,3-2.09,4.15-1.45a2,2,0,0,1,1,2.77c-.38,1.16-4.63,3-6.2,1.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "251.56 95.43 249.75 96.47 250.18 98.86 250.42 99 249.99 96.62 251.81 95.57 251.56 95.43"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.42 99 251.38 98.45 251.81 95.57 249.99 96.62 250.42 99"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M281.62,120.45a3.14,3.14,0,0,0-1.42,2.45c0,.91.64,1.28,1.42.82a3.14,3.14,0,0,0,1.42-2.45C283,120.36,282.4,120,281.62,120.45Z",
    transform: "translate(-29.74 -23.35)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M280.33,119.7a3.11,3.11,0,0,0-1.42,2.46,1,1,0,0,0,.38.9l1.3.75a1,1,0,0,1-.39-.91,3.14,3.14,0,0,1,1.42-2.45,1,1,0,0,1,1-.11l-1.3-.75A1,1,0,0,0,280.33,119.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.62,120.93a2.22,2.22,0,0,0-1,1.73c0,.65.46.91,1,.59a2.23,2.23,0,0,0,1-1.75C282.63,120.86,282.18,120.6,281.62,120.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.44,121.53a1.94,1.94,0,0,1-.88,1.52.59.59,0,0,1-.63.06.57.57,0,0,0,.69,0,1.93,1.93,0,0,0,.88-1.52.59.59,0,0,0-.25-.56A.63.63,0,0,1,282.44,121.53Z",
    transform: "translate(-29.74 -23.35)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M282.25,121a.61.61,0,0,0-.63,0,2,2,0,0,0-.88,1.52.66.66,0,0,0,.19.52.59.59,0,0,0,.63-.06,1.94,1.94,0,0,0,.88-1.52.63.63,0,0,0-.19-.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.06,121.63a1.24,1.24,0,0,1-.56,1,.39.39,0,0,1-.38,0c.08.17.28.2.5.08a1.24,1.24,0,0,0,.57-1,.42.42,0,0,0-.18-.37A.58.58,0,0,1,282.06,121.63Z",
    transform: "translate(-29.74 -23.35)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M281.62,121.43a1.23,1.23,0,0,0-.56,1,.46.46,0,0,0,.06.25.39.39,0,0,0,.38,0,1.24,1.24,0,0,0,.56-1,.58.58,0,0,0-.05-.25A.41.41,0,0,0,281.62,121.43Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "252.76 96.12 250.95 97.17 251.37 99.56 251.62 99.7 251.19 97.3 253 96.26 252.76 96.12"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.62 99.7 252.57 99.14 253 96.26 251.19 97.3 251.62 99.7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282,121.72a.37.37,0,0,1,0,.12.74.74,0,0,1-.33.57.26.26,0,0,1-.18,0c.05.11.16.15.3.07a.74.74,0,0,0,.33-.57A.21.21,0,0,0,282,121.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282,121.72a.34.34,0,0,0-.19,0,.73.73,0,0,0-.32.57.25.25,0,0,0,0,.12.26.26,0,0,0,.18,0,.74.74,0,0,0,.33-.57.37.37,0,0,0,0-.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "249.75 96.47 251.19 97.3 251.19 97.07 249.75 96.24 249.75 96.47"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.19 97.3 253 96.26 253 96.03 251.19 97.07 251.19 97.3"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.75 96.24 251.19 97.07 253 96.03 251.56 95.19 249.75 96.24"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.03 77.8 219.22 78.84 219.64 81.24 219.88 81.38 219.46 78.99 221.27 77.94 221.03 77.8"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.88 81.38 220.84 80.83 221.27 77.94 219.46 78.99 219.88 81.38"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M251.08,102.82a3.17,3.17,0,0,0-1.41,2.46c0,.9.64,1.27,1.41.82a3.14,3.14,0,0,0,1.43-2.46C252.51,102.73,251.87,102.37,251.08,102.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M249.79,102.07a3.14,3.14,0,0,0-1.41,2.46,1,1,0,0,0,.38.9l1.29.75h0a1,1,0,0,1-.38-.9,3.17,3.17,0,0,1,1.41-2.46,1,1,0,0,1,1-.1l-1.31-.75A1,1,0,0,0,249.79,102.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.08,103.3a2.23,2.23,0,0,0-1,1.74c0,.64.45.9,1,.58a2.21,2.21,0,0,0,1-1.74C252.09,103.24,251.64,103,251.08,103.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.9,103.9a2,2,0,0,1-.87,1.53.61.61,0,0,1-.63,0,.54.54,0,0,0,.68,0A1.94,1.94,0,0,0,252,104a.64.64,0,0,0-.25-.56A.68.68,0,0,1,251.9,103.9Z",
    transform: "translate(-29.74 -23.35)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M251.71,103.39a.61.61,0,0,0-.63,0,2,2,0,0,0-.87,1.53.62.62,0,0,0,.19.51h0a.61.61,0,0,0,.63,0,2,2,0,0,0,.87-1.53.68.68,0,0,0-.18-.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M251.53,104a1.28,1.28,0,0,1-.57,1,.4.4,0,0,1-.37.05c.08.16.27.2.49.07a1.24,1.24,0,0,0,.57-1,.4.4,0,0,0-.18-.38A.5.5,0,0,1,251.53,104Z",
    transform: "translate(-29.74 -23.35)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M251.08,103.8a1.25,1.25,0,0,0-.56,1,.42.42,0,0,0,.07.26A.4.4,0,0,0,251,105a1.28,1.28,0,0,0,.57-1,.5.5,0,0,0-.06-.26A.47.47,0,0,0,251.08,103.8Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222.22 78.49 220.41 79.54 220.83 81.93 221.08 82.07 220.66 79.68 222.46 78.63 222.22 78.49"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.08 82.07 222.04 81.52 222.46 78.63 220.66 79.68 221.08 82.07"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.48,104.09a.53.53,0,0,1,0,.12.73.73,0,0,1-.33.57.28.28,0,0,1-.19,0c0,.12.17.15.31.07a.72.72,0,0,0,.32-.57C251.62,104.2,251.57,104.11,251.48,104.09Z",
    transform: "translate(-29.74 -23.35)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.3,104.14a.7.7,0,0,0-.32.56.41.41,0,0,0,0,.12.28.28,0,0,0,.19,0,.73.73,0,0,0,.33-.57.53.53,0,0,0,0-.12A.35.35,0,0,0,251.3,104.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.22 78.84 220.66 79.68 220.66 79.44 219.22 78.62 219.22 78.84"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "220.66 79.68 222.46 78.63 222.46 78.4 220.66 79.44 220.66 79.68"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "219.22 78.62 220.66 79.44 222.46 78.4 221.03 77.57 219.22 78.62"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "266.12 87.02 264.31 88.06 264.74 90.46 264.98 90.6 264.55 88.21 266.37 87.16 266.12 87.02"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.98 90.6 265.93 90.05 266.37 87.16 264.55 88.21 264.98 90.6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M296.18,112a3.11,3.11,0,0,0-1.42,2.46c0,.9.63,1.26,1.42.81a3.14,3.14,0,0,0,1.42-2.45C297.6,112,297,111.59,296.18,112Z",
    transform: "translate(-29.74 -23.35)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.89,111.29a3.17,3.17,0,0,0-1.43,2.46,1,1,0,0,0,.39.9l1.3.75a1,1,0,0,1-.39-.9,3.11,3.11,0,0,1,1.42-2.46,1,1,0,0,1,1-.1l-1.3-.76A1,1,0,0,0,294.89,111.29Z",
    transform: "translate(-29.74 -23.35)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.18,112.51a2.25,2.25,0,0,0-1,1.75c0,.64.45.9,1,.58a2.24,2.24,0,0,0,1-1.74C297.18,112.45,296.73,112.19,296.18,112.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297,113.12a1.94,1.94,0,0,1-.87,1.52.59.59,0,0,1-.63.06.57.57,0,0,0,.69,0,2,2,0,0,0,.88-1.52.59.59,0,0,0-.25-.56A.65.65,0,0,1,297,113.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.81,112.61a.61.61,0,0,0-.63,0,1.94,1.94,0,0,0-.88,1.52.62.62,0,0,0,.19.52h0a.59.59,0,0,0,.63-.06,1.94,1.94,0,0,0,.87-1.52.65.65,0,0,0-.18-.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M296.62,113.22a1.28,1.28,0,0,1-.57,1,.41.41,0,0,1-.38.05c.09.16.28.2.51.07a1.25,1.25,0,0,0,.56-1,.41.41,0,0,0-.17-.38A.58.58,0,0,1,296.62,113.22Z",
    transform: "translate(-29.74 -23.35)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M296.18,113a1.24,1.24,0,0,0-.57,1,.62.62,0,0,0,.06.26.41.41,0,0,0,.38-.05,1.28,1.28,0,0,0,.57-1,.58.58,0,0,0-.05-.25A.4.4,0,0,0,296.18,113Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.32 87.71 265.5 88.75 265.93 91.15 266.17 91.28 265.75 88.89 267.56 87.85 267.32 87.71"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "266.17 91.28 267.13 90.73 267.56 87.85 265.75 88.89 266.17 91.28"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.57,113.31a.42.42,0,0,1,0,.12.74.74,0,0,1-.33.57.28.28,0,0,1-.19,0,.2.2,0,0,0,.31.07.73.73,0,0,0,.32-.57C296.71,113.41,296.66,113.33,296.57,113.31Z",
    transform: "translate(-29.74 -23.35)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.57,113.31a.33.33,0,0,0-.18,0,.74.74,0,0,0-.33.57.37.37,0,0,0,0,.12.28.28,0,0,0,.19,0,.74.74,0,0,0,.33-.57.42.42,0,0,0,0-.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.31 88.06 265.75 88.89 265.75 88.66 264.31 87.83 264.31 88.06"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "265.75 88.89 267.56 87.85 267.56 87.62 265.75 88.66 265.75 88.89"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.31 87.83 265.75 88.66 267.56 87.62 266.12 86.79 264.31 87.83"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.22 75.92 251.19 94.38 267.56 84.92 233.79 67.51 219.22 75.92"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.22 78.62 251.19 97.07 251.19 94.38 219.22 75.92 219.22 78.62"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.19 97.07 267.56 87.62 267.56 84.92 251.19 94.38 251.19 97.07"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.09 77 235.66 68.59 235.66 54.08 221.09 62.49 221.09 77"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.22 75.93 221.09 77 221.09 62.49 219.22 61.41 219.22 75.93"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "219.22 61.41 221.09 62.49 235.66 54.08 233.78 52.99 219.22 61.41"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.19 79.86 251.19 94.38 267.56 84.92 267.56 70.4 257.98 75.94 251.19 79.86"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "249.31 93.3 251.19 94.38 251.19 79.86 249.31 78.78 249.31 93.3"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.31 78.78 251.19 79.86 267.56 70.4 265.68 69.32 249.31 78.78"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.22 25.24 251.19 43.7 267.56 34.24 235.59 15.78 219.22 25.24"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.22 61.4 251.19 79.86 251.19 43.7 219.22 25.24 219.22 61.4"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "221.52 61.06 248.88 76.85 248.88 70.05 221.52 54.25 221.52 61.06"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 56.22 248.88 72.02 248.88 70.88 221.52 55.09 221.52 56.22"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 60.72 248.88 76.52 248.88 75.38 221.52 59.58 221.52 60.72"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 58.48 248.88 74.27 248.88 73.13 221.52 57.34 221.52 58.48"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "221.52 35.11 248.88 50.91 248.88 44.1 221.52 28.3 221.52 35.11"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 30.28 248.88 46.07 248.88 44.93 221.52 29.14 221.52 30.28"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 34.78 248.88 50.57 248.88 49.43 221.52 33.64 221.52 34.78"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 32.53 248.88 48.32 248.88 47.18 221.52 31.39 221.52 32.53"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "221.52 43.93 248.88 59.73 248.88 52.92 221.52 37.12 221.52 43.93"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 39.1 248.88 54.89 248.88 53.76 221.52 37.96 221.52 39.1"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 43.59 248.88 59.39 248.88 58.25 221.52 42.45 221.52 43.59"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 41.35 248.88 57.14 248.88 56.01 221.52 40.21 221.52 41.35"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "221.52 52.55 248.88 68.35 248.88 61.55 221.52 45.75 221.52 52.55"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 47.73 248.88 63.52 248.88 62.38 221.52 46.58 221.52 47.73"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 52.22 248.88 68.01 248.88 66.88 221.52 51.08 221.52 52.22"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.52 49.98 248.88 65.77 248.88 64.63 221.52 48.84 221.52 49.98"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.19 79.86 267.56 70.4 267.56 34.24 251.19 43.7 251.19 79.86"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M273.13,54.25l-.33-.19.24-.14a2.53,2.53,0,0,1,.55,0l-.11.29Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "253.68 35.49 252.37 35.29 252.37 36.43 253.68 36.63 253.68 35.49"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M271,54.14V55.3h0c0,.58.78.9.78.9a3.55,3.55,0,0,0,1.78.26,2.15,2.15,0,0,1,1.43.37l5.32,3.07v.65h0a1.07,1.07,0,0,0,.63.86,3.33,3.33,0,0,0,3,0,1.06,1.06,0,0,0,.62-.86h0V59.39l-.55.83-.07.05a3.38,3.38,0,0,1-2.85.08l-.79-1a.92.92,0,0,1,.2-.52L275,55.68a2.18,2.18,0,0,0-1.43-.36,3.55,3.55,0,0,1-1.78-.26,2.19,2.19,0,0,1-.29-.17Zm9.31,5.27h0Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "244.01 30.12 243.06 29.57 243.06 30.71 244.01 31.26 244.01 30.12"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "252.02 36.63 252.37 36.43 252.37 35.29 251.41 35.84 251.76 36.6 252.02 36.63"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "253.68 36.45 254.03 36.25 253.68 35.49 253.68 36.45"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275,55.68l5.52,3.19c-.37.46-.23,1,.43,1.4a3.33,3.33,0,0,0,3,0,.92.92,0,0,0,0-1.74,3.31,3.31,0,0,0-2.35-.26L276,55.06c-.86-.49-.63-.82-.63-.82.24-.52-.46-1-.46-1h0a2.86,2.86,0,0,0-1.91-.43l-.24.13.95.55-.27.75-1.29.16-.95-.56L271,54c-.19.7.75,1.11.75,1.11a3.55,3.55,0,0,0,1.78.26A2.18,2.18,0,0,1,275,55.68Zm7.15,3,1.31.21.35.75-1,.56-1.31-.21-.35-.75Z",
    transform: "translate(-29.74 -23.35)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M275.33,55.61l.07,0h0a.7.7,0,0,1,.6,0l4.46,2.58a.18.18,0,0,1,.07,0c.09-.1.07-.22-.07-.3L276,55.31a.7.7,0,0,0-.6,0h0C275.26,55.4,275.24,55.52,275.33,55.61Z",
    transform: "translate(-29.74 -23.35)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M275.33,55.61l.07,0,4.46,2.58a.7.7,0,0,0,.6,0h0l.07,0a.18.18,0,0,0-.07,0L276,55.56a.7.7,0,0,0-.6,0h0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M279.89,52.44a.9.9,0,0,0,.3-.68h0v.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M275.64,51.76s0,0,0,0v0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M276.3,52.72a3.62,3.62,0,0,0,2.75.21l6.16,3.56c-.36.41-.25.93.35,1.27a3,3,0,0,0,2.7,0,1,1,0,0,0,.55-.75h0v1.13h0a1,1,0,0,1-.55.77,3,3,0,0,1-2.7,0,1,1,0,0,1-.56-.79h0v-.61l-5.95-3.44a3.62,3.62,0,0,1-2.75-.21,1.11,1.11,0,0,1-.66-1h0V51.79A1.15,1.15,0,0,0,276.3,52.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "256.14 33.04 257.54 32.83 257.54 33.97 256.3 34.16 256.14 34.07 256.14 33.04"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "258.03 34.25 258.19 34.23 258.57 33.42 257.54 32.83 257.54 33.97 258.03 34.25"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "256.14 34.07 256.14 33.04 255.76 33.85 256.14 34.07"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "246.97 28.89 248.61 28.64 248.61 27.5 246.97 27.75 246.97 28.89"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "248.61 28.64 249.39 29.09 249.81 28.19 248.61 27.5 248.61 28.64"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "246.53 28.7 246.95 28.94 246.97 28.89 246.97 27.75 246.53 28.7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.3,50.86a1,1,0,0,0,0,1.86,3.62,3.62,0,0,0,2.75.21l6.16,3.56c-.36.41-.25.93.35,1.27a3,3,0,0,0,2.7,0,.83.83,0,0,0,0-1.56,3,3,0,0,0-2.21-.2l-6.16-3.56c.5-.5.38-1.15-.36-1.58A3.54,3.54,0,0,0,276.3,50.86Zm9.58,5.53,1.4-.22,1,.59-.38.81-1.4.22-1-.59Zm-9.17-5.29,1.64-.26,1.2.7-.44.94-1.64.26-1.2-.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M258.83,58.59c-2.13,1.4-3.53,5.85-3.2,7.68s3.78,3.27,3.78,3.27,2.58-1.8,3.93-9.61C263.27,59,261,57.18,258.83,58.59Z",
    transform: "translate(-29.74 -23.35)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M269,41.75c-1.63-.06-6.28,1.77-6.28,1.77a15.86,15.86,0,0,0,1.14,3c.29.16,6.3,1.67,6.7.68s-2.29-1-2.29-1.89,1.74.08,2.61-.17,2.64-.62,2.67-1.46S270.64,41.8,269,41.75Z",
    transform: "translate(-29.74 -23.35)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M262.73,43.52c-.7.08-2.83.59-4.14.69s.43,4.5,1.24,3.6a9.26,9.26,0,0,0,4.22-1.4C264.18,46.3,264.56,43.37,262.73,43.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M256.64,29.34l-1.17,1.81c-.92,3.21-4.94,6.09-4.94,6.09l1.88,4.68,6.89,1.24a2.08,2.08,0,0,1,.3-2.48,2.56,2.56,0,0,1,1.28-.36l.84-1.54,1.33-4.16L261,31.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.82,37.18c-2,.8-2.83,3-.71,8.3,2.46,6.17,4.26.88,6.89-.1s7.38-1.21,2.53-6C249.42,37.26,245.68,36,242.82,37.18Z",
    transform: "translate(-29.74 -23.35)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M259.23,41.41s-2.69-2-5-3.51c-3.66-1.75-4.71-.89-6.2-.92s-4.71.47-5.83,7.89c-.88,5.81.24,8.86.28,14.22,0,3.51-.57,5.4-.3,7,.39,2.25,1.14,7,8,7.9s9.23-4.44,9.23-4.44a36.62,36.62,0,0,1,.78-4.44c1.53-6.51,6-10.9,3.05-18.91A10.06,10.06,0,0,1,259.23,41.41Z",
    transform: "translate(-29.74 -23.35)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.06,117.45,239,119.3s-1.17,4.21-.73,5.36a2.11,2.11,0,0,0,2.7,1.19c1.42-.67,2.09-2.56,2.89-3.38,1-1,3.67-2.14,3.31-3.63A2,2,0,0,0,245.06,117.45Z",
    transform: "translate(-29.74 -23.35)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M240,75.13c1.22,12.14,1.87,19.21,2.32,21.56-3.65,3.4-4.69,17.27-4.7,21.7,0,3,6.71,3,7.61-.08a115.45,115.45,0,0,1,3.33-15.49c3.15-4.84,3.07-22.64,3.07-22.64S240.21,73,240,75.13Z",
    transform: "translate(-29.74 -23.35)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M271,119.45c-1.31-.63-4.16.12-5.36-.56s-7.53,2.18-7.53,2.18-1.35,4.54.89,5.35,9.86-1.08,11.69-2.2S272.31,120.09,271,119.45Z",
    transform: "translate(-29.74 -23.35)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M259.41,69.54a13.26,13.26,0,0,1-7.14,1.69,14.1,14.1,0,0,1-10.09-5.15c-1.57,3.16-3.16,9-1.44,12.18,1.13,2.07,5.73,3.7,10.31,6.53.22.63,4.75,10.78,7,15-2,5.12-.84,12.85-1.07,21.81.57,3.09,8.92,1.75,9.25-1.69-1.21-5.11,0-11.8,0-21.58A124.4,124.4,0,0,0,259.41,69.54Z",
    transform: "translate(-29.74 -23.35)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M240.76,72.6a6.58,6.58,0,0,0-2.34,5.9c0,1.25,3.35,3.8,5.2,3.12-1.34-4.68,1-7,1-7S242.05,72,240.76,72.6Z",
    transform: "translate(-29.74 -23.35)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M266.12,25l-3.69,1.43s-1.1,6.75-1.2,7.39c.55,3.4-1.63,6.83-1.63,6.83a2.38,2.38,0,0,0,1.6.38c1.31-.12,5-4.91,6.24-7.47a8,8,0,0,0,.56-5.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M261.54,23.37c-5.83.39-6.3,7.53-6.07,7.78s1.71.34,2.41.68c.54.26,2.39,2.17,3.43,2.22s3.15-2.14,4.05-2.11-.37,2.14,0,2.48,1.9-1.72,2.25-3-.62-2.93-.4-3.55.67.52.79,0C268.17,27.11,267.46,23,261.54,23.37Z",
    transform: "translate(-29.74 -23.35)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.81,71.31a21.42,21.42,0,0,0-5.55.37c-1.23-.06-2.66,2.61-1.29,3.73.2.61,4.23,2.62,6.82,1.57,1-.43,3.42-3.21,2.95-4.23C284.39,72,283.4,71.51,281.81,71.31Z",
    transform: "translate(-29.74 -23.35)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M269.53,66.49c-.09,0-1.07-4.58-1.35-4.89-1.08-1.26-4.65,1.67-6,2.77a18.46,18.46,0,0,0,2.17,5.28c2.36,4.43,6.85,4.39,10.64,5.76,0,0,3.27-.73,1.29-3.73C274.43,70.79,272.67,67.87,269.53,66.49Z",
    transform: "translate(-29.74 -23.35)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M267.72,56.67c-.92-5.21-1.25-11.86-7.79-10.65-1.27.27-2,3.85-1.07,8.24.86,3.41,1.09,6.25,2.75,11,1.3,2.07,8,0,7.57-2.14A36.29,36.29,0,0,1,267.72,56.67Z",
    transform: "translate(-29.74 -23.35)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.27,37c.6-.57-1.72-1-2.25-.23-8.31,15.72,2.25,34.83,2.25,34.83h2.84S242,50.14,250.27,37Z",
    transform: "translate(-29.74 -23.35)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M259.75,42.58c-12.29,2.36-17.57,23.5-17.57,23.5l.27,1.58L244,68s5-21.66,17.68-23C261.72,45,260.67,42.53,259.75,42.58Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "247.81 133.64 222.97 119.28 222.97 142.87 267.31 168.48 247.81 133.64"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.09 128.85 62.72 170.63 80.44 181.5 83.06 179.76 83.08 179.77 98.83 169.52 108.3 178.4 114.84 194.12 114.72 198 206.88 251.09 207.33 254.76 254.81 282.17 327.74 240.07 135.09 128.85"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.8,195.59l-24.23-41.85L221.69,120.9l-19.53,16.37L164.82,121.9v30.29l18.27,10.55c0-10.58,7.42-14.86,16.58-9.58s16.59,18.15,16.59,28.73l141.21,81.53.22-26.72Zm-53.35-31.25L210.93,142.1l15.65-14.55,22.87,13.25Zm3.26,1.87V142.62L277.55,157l19.5,34.84Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "259.32 185.64 233.4 170.68 233.4 152.45 259.32 167.42 259.32 185.64"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "259.32 174.79 233.4 159.83 233.4 156.9 259.32 171.86 259.32 174.79"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "271.95 207.87 203.66 247.34 203.66 216.98 271.95 177.63 271.95 207.87"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "284.12 153.7 272.98 160.16 271.03 159.03 282.17 152.58 284.12 153.7"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "272.98 169.05 271.03 167.92 271.03 159.03 272.98 160.16 272.98 169.05"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "284.12 162.59 272.98 169.05 272.98 160.16 284.12 153.7 284.12 162.59"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.71,191.1a2.26,2.26,0,0,0-1-1.78.69.69,0,0,0-.75,0L298,191l1.42,2.53,3-1.73h0A.71.71,0,0,0,302.71,191.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M299.73,192.84c0,.66-.46.92-1,.6a2.28,2.28,0,0,1-1-1.78c0-.66.46-.92,1-.6A2.28,2.28,0,0,1,299.73,192.84Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.5 156.03 62.16 140.66 135.08 98.56 172.42 113.92 99.5 156.03"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "241.02 251.61 67.13 151.22 67.13 170.41 79.78 177.71 80.44 181.5 83.13 179.64 83.21 179.69 98.83 169.52 108.3 178.4 114.84 194.12 114.73 197.89 203.5 249.14 204.12 252.9 206.88 251.09 249.43 275.66 241.02 251.61"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M120.72,203.5h0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M129.61,220.15l0,0,0,0Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "92.48 188.35 95.31 190.99 111.86 181.44 109.03 178.8 92.48 188.35"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M127.89,202.78c-1.78-1.1-3.41-1.26-4.63-.64h0l0,0s0,0,0,0l-2.41,1.3c1.23-.65,2.89-.5,4.69.62a14.72,14.72,0,0,1,6.3,11.77c-.06,2.12-.85,3.59-2.08,4.25l2.28-1.25c1.31-.61,2.17-2.1,2.25-4.32A14.79,14.79,0,0,0,127.89,202.78Z",
    transform: "translate(-29.74 -23.35)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M125.45,204.1c-3.62-2.24-6.66-.62-6.79,3.64a14.75,14.75,0,0,0,6.3,11.77c3.62,2.24,6.66.61,6.79-3.64A14.72,14.72,0,0,0,125.45,204.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M125.34,207.58c-2-1.23-3.65-.34-3.73,2a8.1,8.1,0,0,0,3.46,6.45c2,1.24,3.65.34,3.73-2A8.11,8.11,0,0,0,125.34,207.58Z",
    transform: "translate(-29.74 -23.35)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M125.23,211c-.39-.24-.71-.06-.73.4a1.6,1.6,0,0,0,.68,1.26c.39.24.71.06.73-.39A1.62,1.62,0,0,0,125.23,211Z",
    transform: "translate(-29.74 -23.35)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M240.1,268h0l0,0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M260.32,303.09h0l.09-.05Z",
    transform: "translate(-29.74 -23.35)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M258.41,264.25c-3.88-2.24-7.4-2.48-10-1.07h0l-.1.06-.08,0-8.06,4.64c2.59-1.48,6.16-1.26,10.11,1,7.91,4.57,14.33,15.68,14.33,24.82,0,4.57-1.6,7.77-4.19,9.27l7.79-4.52c2.78-1.41,4.53-4.68,4.53-9.43C272.75,279.94,266.33,268.82,258.41,264.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M264.62,293.76c0,9.14-6.42,12.85-14.33,8.28S236,286.35,236,277.21s6.42-12.84,14.34-8.27S264.62,284.62,264.62,293.76Z",
    transform: "translate(-29.74 -23.35)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M258.14,290c0,5-3.51,7-7.85,4.54A17.38,17.38,0,0,1,242.43,281c0-5,3.52-7,7.86-4.53A17.33,17.33,0,0,1,258.14,290Z",
    transform: "translate(-29.74 -23.35)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M251.83,286.38c0,1-.69,1.38-1.54.89a3.43,3.43,0,0,1-1.54-2.67c0-1,.69-1.38,1.54-.89A3.41,3.41,0,0,1,251.83,286.38Z",
    transform: "translate(-29.74 -23.35)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M214.88,160.52c-.67-8.42-3.14-16.14-5.51-17.25a1.2,1.2,0,0,0-.78-.09v0l-.1.06a1.27,1.27,0,0,0-.43.25l-58.64,34.78,4.31,30.69,59-35v0C214.51,173.3,215.48,167.86,214.88,160.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M155.79,195.64c.67,8.42-.7,14.35-3.07,13.25s-4.84-8.83-5.52-17.25.7-14.35,3.07-13.25S155.11,187.21,155.79,195.64Z",
    transform: "translate(-29.74 -23.35)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M237.07,189.21c0-2.66-3.42-6.62-11.12-11.07-6.06-3.49-11.19-5.12-13.12-4.37h0l-.07,0a2,2,0,0,0-.25.14l-59.27,35.25,24.05,16.69,59-35.53a1.47,1.47,0,0,0,.39-.22l.07,0h0A1.14,1.14,0,0,0,237.07,189.21Z",
    transform: "translate(-29.74 -23.35)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M178,224.33c0,2.66-3.42,3-11.12-1.42S152.9,212.69,152.9,210s6.24-1.22,13.95,3.23S178,221.67,178,224.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M264.77,177.93c-.68-8.42-3.15-16.13-5.52-17.24a1.17,1.17,0,0,0-.77-.09v0l-.09.06a1.16,1.16,0,0,0-.44.25L228,178.41l4.31,30.69,30.25-17.81v0C264.39,190.72,265.36,185.28,264.77,177.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M234.37,195.81c.68,8.42-.69,14.35-3.06,13.25s-4.84-8.82-5.52-17.24.69-14.35,3.07-13.25S233.7,187.39,234.37,195.81Z",
    transform: "translate(-29.74 -23.35)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M287,206.63c0-2.66-3.42-6.62-11.12-11.07-6.05-3.49-11.19-5.12-13.12-4.38h0l-.07,0a1.17,1.17,0,0,0-.25.14l-30.58,18,24.06,16.7,30.28-18.29a1.47,1.47,0,0,0,.39-.22l.06,0h0A1.1,1.1,0,0,0,287,206.63Z",
    transform: "translate(-29.74 -23.35)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M256.56,224.5c0,2.67-3.42,3-11.13-1.42s-13.94-10.21-13.94-12.88,6.24-1.21,13.94,3.24S256.56,221.84,256.56,224.5Z",
    transform: "translate(-29.74 -23.35)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M227.73,199.36c-.67-8.42-3.15-16.14-5.52-17.24a1.17,1.17,0,0,0-.77-.1v0l-.1.06a1.46,1.46,0,0,0-.43.25L191,199.83l4.31,30.69,30.25-17.81v0C227.35,212.14,228.32,206.7,227.73,199.36Z",
    transform: "translate(-29.74 -23.35)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M197.34,217.23c.67,8.42-.7,14.35-3.07,13.25s-4.84-8.82-5.52-17.24.7-14.35,3.07-13.25S196.66,208.81,197.34,217.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M249.92,228.05c0-2.66-3.42-6.62-11.13-11.07-6-3.49-11.19-5.12-13.12-4.37h0l-.07,0a2,2,0,0,0-.25.14l-30.57,18,24,16.69,30.28-18.29a1.47,1.47,0,0,0,.39-.22l.06,0h0A1.13,1.13,0,0,0,249.92,228.05Z",
    transform: "translate(-29.74 -23.35)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M219.52,245.92c0,2.67-3.42,3-11.12-1.42s-14-10.21-14-12.87,6.24-1.22,14,3.23S219.52,243.26,219.52,245.92Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "320.96 214.35 271.95 177.63 271.95 207.87 302.07 225.26 320.96 214.35"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "272.14 207.99 272.14 195.66 281.99 189.98 281.99 202.3 272.14 207.99"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "272.14 207.99 260.06 200.98 260.06 188.65 272.14 195.66 272.14 207.99"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "272.14 195.66 260.06 188.65 269.91 182.96 281.99 189.98 272.14 195.66"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M313.47,240.37V221.21h-1.8l-.32-.2a11.31,11.31,0,0,0-10.23,0l-.32.2H299v19.21h0a3.59,3.59,0,0,0,2.12,3,11.31,11.31,0,0,0,10.23,0A3.57,3.57,0,0,0,313.47,240.37Z",
    transform: "translate(-29.74 -23.35)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M311.35,224.27a11.31,11.31,0,0,1-10.23,0c-2.83-1.63-2.83-4.28,0-5.91a11.31,11.31,0,0,1,10.23,0C314.18,220,314.18,222.64,311.35,224.27Z",
    transform: "translate(-29.74 -23.35)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M311.66,221.91a3.36,3.36,0,0,0-1.46-1.49,8.92,8.92,0,0,0-7.93,0,3.36,3.36,0,0,0-1.46,1.49c-.49-1.09,0-2.27,1.46-3.1a8.73,8.73,0,0,1,7.93,0C311.66,219.64,312.15,220.82,311.66,221.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M311.66,221.91a3.18,3.18,0,0,1-1.46,1.48,8.73,8.73,0,0,1-7.93,0,3.22,3.22,0,0,1-1.46-1.48,3.36,3.36,0,0,1,1.46-1.49,8.92,8.92,0,0,1,7.93,0A3.36,3.36,0,0,1,311.66,221.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "258.22 214.44 258.22 203.3 267.12 198.16 267.12 209.3 258.22 214.44"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "258.22 214.44 247.3 208.1 247.3 196.96 258.22 203.3 258.22 214.44"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "258.22 203.3 247.3 196.96 256.2 191.82 267.12 198.16 258.22 203.3"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "307.32 221.53 296.51 227.78 296.51 212.88 307.32 206.63 307.32 221.53"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "289.75 196.49 278.94 202.73 296.51 212.88 307.32 206.63 289.75 196.49"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "298.49 202.36 297.95 202.68 297.13 202.22 288.23 207.35 287.68 207.05 297.13 201.6 298.49 202.36"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "297.95 202.68 289.05 207.81 288.23 207.35 297.13 202.22 297.95 202.68"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "296.51 227.78 278.94 217.63 278.94 202.73 296.51 212.88 296.51 227.78"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "294.81 224.94 294.81 225.55 280.64 217.37 280.64 208.63 281.19 208.96 281.19 217.08 294.81 224.94"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "294.81 216.81 294.81 224.94 281.19 217.08 281.19 208.96 294.81 216.81"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M324.57,238c0,.66-.46.93-1,.6a2.29,2.29,0,0,1-1-1.81c0-.66.46-.93,1-.6A2.29,2.29,0,0,1,324.57,238Z",
    transform: "translate(-29.74 -23.35)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.63,236.54v.81l.67.39V238l-.67-.39v.82l-.2-.11v-.82l-.67-.39v-.21l.67.39v-.81Z",
    transform: "translate(-29.74 -23.35)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M312.35,231c0,.66-.47.93-1,.6a2.3,2.3,0,0,1-1.05-1.81c0-.66.47-.93,1.05-.6A2.31,2.31,0,0,1,312.35,231Z",
    transform: "translate(-29.74 -23.35)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.08,230.68v.21l-1.54-.89v-.21Z",
    transform: "translate(-29.74 -23.35)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M327,229.39v1.28h0a.77.77,0,0,0,.46.64,2.46,2.46,0,0,0,2.24,0,.77.77,0,0,0,.46-.64v-1.28Z",
    transform: "translate(-29.74 -23.35)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M329.67,230a2.52,2.52,0,0,1-2.24,0c-.62-.36-.62-.94,0-1.29a2.46,2.46,0,0,1,2.24,0C330.29,229.1,330.29,229.68,329.67,230Z",
    transform: "translate(-29.74 -23.35)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M316.59,223.45v1.28h0a.78.78,0,0,0,.47.64,2.44,2.44,0,0,0,2.23,0,.78.78,0,0,0,.47-.64v-1.28Z",
    transform: "translate(-29.74 -23.35)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M319.29,224.1a2.5,2.5,0,0,1-2.23,0c-.62-.36-.62-.94,0-1.29a2.44,2.44,0,0,1,2.23,0C319.91,223.16,319.91,223.74,319.29,224.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "210.34 231.39 221.08 237.6 221.08 222.79 210.34 216.59 210.34 231.39"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "235.48 202.05 246.22 208.25 221.08 222.79 210.34 216.59 235.48 202.05"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "221.08 237.6 246.22 223.06 246.22 208.25 221.08 222.79 221.08 237.6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M271.21,227.14V231h0a2.41,2.41,0,0,1-1.41,2,7.56,7.56,0,0,1-6.81,0,2.41,2.41,0,0,1-1.41-2v-3.88Z",
    transform: "translate(-29.74 -23.35)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M263,229.1a7.5,7.5,0,0,0,6.81,0c1.88-1.08,1.88-2.84,0-3.93a7.56,7.56,0,0,0-6.81,0C261.11,226.26,261.11,228,263,229.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M263.1,227.67a2.06,2.06,0,0,1,.88-.88,5.4,5.4,0,0,1,4.83,0,1.82,1.82,0,0,1,.85.88c.33-.65,0-1.41-.85-1.92a5.28,5.28,0,0,0-4.83,0C263.08,226.26,262.78,227,263.1,227.67Z",
    transform: "translate(-29.74 -23.35)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M263.1,227.67a2,2,0,0,0,.88.86,5.4,5.4,0,0,0,4.83,0,1.76,1.76,0,0,0,.85-.86,1.82,1.82,0,0,0-.85-.88,5.4,5.4,0,0,0-4.83,0A2.06,2.06,0,0,0,263.1,227.67Z",
    transform: "translate(-29.74 -23.35)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M262.19,232.3v3.88h0a2.41,2.41,0,0,1-1.41,2,7.56,7.56,0,0,1-6.81,0,2.41,2.41,0,0,1-1.41-2V232.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M254,234.26a7.5,7.5,0,0,0,6.81,0c1.88-1.08,1.88-2.84,0-3.93a7.5,7.5,0,0,0-6.81,0C252.09,231.42,252.09,233.18,254,234.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M254.09,232.83A2.06,2.06,0,0,1,255,232a5.38,5.38,0,0,1,4.82,0,1.89,1.89,0,0,1,.86.88c.32-.65.05-1.41-.86-1.92a5.26,5.26,0,0,0-4.82,0C254.06,231.42,253.76,232.18,254.09,232.83Z",
    transform: "translate(-29.74 -23.35)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M254.09,232.83a2,2,0,0,0,.88.86,5.38,5.38,0,0,0,4.82,0,1.87,1.87,0,0,0,.86-.86,1.89,1.89,0,0,0-.86-.88,5.38,5.38,0,0,0-4.82,0A2.06,2.06,0,0,0,254.09,232.83Z",
    transform: "translate(-29.74 -23.35)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M282.9,262.29c2.43-2.92,5.35-4,7.21-3h0l5.06,2.92c-1.87-1-4.75.12-7.15,3-3,3.57-4.08,8.5-2.47,11a3,3,0,0,0,1,1h0l-5.07-2.92h0a3.14,3.14,0,0,1-1-1C278.83,270.78,279.93,265.86,282.9,262.29Z",
    transform: "translate(-29.74 -23.35)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M265,252c2.42-2.92,5.34-4,7.21-3h0l5.06,2.92c-1.87-1-4.76.12-7.16,3-3,3.57-4.07,8.5-2.46,11a3.09,3.09,0,0,0,1,1h0L263.58,264h0a3.24,3.24,0,0,1-1-1C261,260.47,262.06,255.54,265,252Z",
    transform: "translate(-29.74 -23.35)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M270.1,254.89c2.43-2.92,5.35-4,7.21-3l7.7,4.45,5.06,2.93c-1.87-1-4.76.12-7.16,3-3,3.57-4.07,8.49-2.46,11a3.09,3.09,0,0,0,1,1h0l-12.77-7.38h0a3.13,3.13,0,0,1-1-1C266,263.39,267.13,258.47,270.1,254.89Z",
    transform: "translate(-29.74 -23.35)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M288,265.24c-3,3.57-4.08,8.5-2.47,11s5.32,1.63,8.29-1.94,4.08-8.5,2.47-11S291,261.67,288,265.24Z",
    transform: "translate(-29.74 -23.35)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M287.13,275.19c1.26,1.8,4.05,1.11,6.28-1.58s3.12-6.51,1.89-8.42a2.29,2.29,0,0,0-.86-.81.36.36,0,0,1,.07.1c1.23,1.91.39,5.68-1.89,8.42C290.78,275.12,288.56,276,287.13,275.19Z",
    transform: "translate(-29.74 -23.35)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M287.06,275.1l.07.09c1.43.78,3.65-.07,5.49-2.29,2.28-2.74,3.12-6.51,1.89-8.42a.36.36,0,0,0-.07-.1c-1.43-.78-3.65.08-5.49,2.29C286.68,269.41,285.83,273.18,287.06,275.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M277.69,253.34V246H277l-.12-.08a4.36,4.36,0,0,0-3.92,0l-.12.08h-.69v7.36h0a1.37,1.37,0,0,0,.81,1.13,4.3,4.3,0,0,0,3.92,0A1.38,1.38,0,0,0,277.69,253.34Z",
    transform: "translate(-29.74 -23.35)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M276.87,247.17a4.3,4.3,0,0,1-3.92,0,1.2,1.2,0,0,1,0-2.27,4.36,4.36,0,0,1,3.92,0A1.2,1.2,0,0,1,276.87,247.17Z",
    transform: "translate(-29.74 -23.35)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M277,246.26a1.27,1.27,0,0,0-.56-.57,3.45,3.45,0,0,0-3,0,1.38,1.38,0,0,0-.56.57c-.19-.41,0-.86.56-1.18a3.33,3.33,0,0,1,3,0C277,245.4,277.18,245.85,277,246.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M277,246.26a1.14,1.14,0,0,1-.56.57,3.33,3.33,0,0,1-3,0,1.22,1.22,0,0,1-.56-.57,1.38,1.38,0,0,1,.56-.57,3.45,3.45,0,0,1,3,0A1.27,1.27,0,0,1,277,246.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "231.41 244.12 231.41 232.15 236.84 229.01 236.84 240.99 231.41 244.12"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "231.41 244.12 224.75 240.26 224.75 228.28 231.41 232.15 231.41 244.12"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "231.41 232.15 224.75 228.28 230.18 225.15 236.84 229.01 231.41 232.15"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "239.31 250.3 239.31 238.32 244.74 235.19 244.74 247.16 239.31 250.3"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "239.31 250.3 232.66 246.43 232.66 234.46 239.31 238.32 239.31 250.3"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "239.31 238.32 232.66 234.46 238.09 231.32 244.74 235.19 239.31 238.32"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "272.92 206.43 271.4 209.07 267.03 206.55 268.55 203.91 272.92 206.43"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "278.88 209.87 272.62 220.65 275.15 211.23 271.4 209.07 272.92 206.43 278.88 209.87"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "274.69 204.67 273.49 206.75 270.26 204.9 271.47 202.82 274.69 204.67"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "278.69 206.98 277.48 209.07 273.49 206.75 274.69 204.67 278.69 206.98"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "279.87 210.43 278.36 213.07 273.98 210.55 275.5 207.91 279.87 210.43"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "285.84 213.87 279.57 224.66 282.11 215.24 278.36 213.07 279.87 210.43 285.84 213.87"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "281.64 208.67 280.44 210.76 277.22 208.91 278.42 206.82 281.64 208.67"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "285.64 210.99 284.44 213.07 280.44 210.76 281.64 208.67 285.64 210.99"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M293.53,247.29l-9.62,5.55c-.77.45-1.44.18-1.58-.64l-2-11.35A3.52,3.52,0,0,1,282,237.7l13.54-7.81c1-.58,1.77.05,1.58,1.32l-2,13.61A3.63,3.63,0,0,1,293.53,247.29Z",
    transform: "translate(-29.74 -23.35)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M296.6,229.77l21.89,12.64-.16.68-22.84-13.2A1.18,1.18,0,0,1,296.6,229.77Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "286.52 214.26 285 216.9 280.63 214.38 282.14 211.74 286.52 214.26"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "292.48 217.7 286.21 228.48 288.75 219.06 285 216.9 286.52 214.26 292.48 217.7"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "288.29 212.5 287.08 214.58 283.86 212.73 285.07 210.65 288.29 212.5"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "292.29 214.81 291.08 216.9 287.08 214.58 288.29 212.5 292.29 214.81"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M314.32,263.78l-7.5,4.34c-.47.27-.86.05-.86-.5v-4.26l9.22-5.33v4.27A1.88,1.88,0,0,1,314.32,263.78Z",
    transform: "translate(-29.74 -23.35)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M306.23,264.22l-18.68-10V257a.57.57,0,0,0,.27.56l18.41,10.68Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "252.21 214.36 274.06 226.97 287.6 219.16 265.75 206.54 252.21 214.36"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M282.79,253l21.85,12.61-.46-.74L282.33,252.2A1.15,1.15,0,0,0,282.79,253Z",
    transform: "translate(-29.74 -23.35)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M303.8,250.32,282,237.7a3.26,3.26,0,0,0-1.58,3.15l21.85,12.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M315.38,259.9l-9.62,5.55c-.77.45-1.44.18-1.58-.63l-2-11.35a3.5,3.5,0,0,1,1.58-3.15l13.54-7.82c1-.58,1.77.06,1.58,1.32l-2,13.62A3.61,3.61,0,0,1,315.38,259.9Z",
    transform: "translate(-29.74 -23.35)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M318,244.57a3.14,3.14,0,0,1-1.42,2.45c-.78.45-1.42.09-1.42-.82a3.14,3.14,0,0,1,1.42-2.45C317.33,243.3,318,243.66,318,244.57Z",
    transform: "translate(-29.74 -23.35)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M316.17,257.46a2.06,2.06,0,0,1-.93,1.61c-.51.29-.93.06-.93-.54a2,2,0,0,1,.93-1.6C315.75,256.63,316.17,256.87,316.17,257.46Z",
    transform: "translate(-29.74 -23.35)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M306.89,262.82a2.07,2.07,0,0,1-.93,1.61c-.51.29-.93.05-.93-.54a2,2,0,0,1,.93-1.6C306.47,262,306.89,262.23,306.89,262.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M306,251.5a3.11,3.11,0,0,1-1.42,2.45c-.78.46-1.41.09-1.41-.81a3.13,3.13,0,0,1,1.41-2.46C305.33,250.23,306,250.6,306,251.5Z",
    transform: "translate(-29.74 -23.35)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M292.7,229.14h0a1.18,1.18,0,0,0-1.17.11l-5.61,3.24a3.7,3.7,0,0,0-1.66,2.88v1L306.11,249l8.46-7.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M307.77,245.1l5.6-3.23c.92-.53,1.66-.1,1.66,1v1L306.11,249v-1A3.67,3.67,0,0,1,307.77,245.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M311.52,253a2.1,2.1,0,0,1-.95,1.65c-.52.3-.95.05-.95-.55a2.09,2.09,0,0,1,.95-1.64C311.1,252.17,311.52,252.42,311.52,253Z",
    transform: "translate(-29.74 -23.35)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M310.33,252l-.95-.55-.76-3.53a2.74,2.74,0,0,1,1.25-2.16l2.65-1.53,1,.54Z",
    transform: "translate(-29.74 -23.35)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M313.11,251.05l-1.64-.94,1.9-4.52c.48-.85,1.28-1.3,1.76-1l1.87,1.08Z",
    transform: "translate(-29.74 -23.35)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M318.26,248.42l-.92-.53h0a.87.87,0,0,0-.88.09L313,250.84v2.67Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "287.3 230.87 286.35 230.32 283.38 229.85 281.74 232.68 284.48 235.6 285.42 236.15 287.3 230.87"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M309.4,257.13l2.31-1.33.76,3.53a2.78,2.78,0,0,1-1.24,2.16l-1.7,2.07-.95-.54Z",
    transform: "translate(-29.74 -23.35)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M308,256.17l1.63.95-1.89,4.52c-.49.84-1.28,1.3-1.77,1l-1.87-1.08Z",
    transform: "translate(-29.74 -23.35)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M308.33,254.52l-1-.53-3.93,1.48v3.06a.87.87,0,0,0,.34.78h0l1.06.6.13-1h0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M307.83,248.82,306,254.1l-.95-.54c-.49-.29-.49-1.2,0-2l1.87-3.24Z",
    transform: "translate(-29.74 -23.35)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M312.64,250.64,310.33,252l-.76-3.54a2.77,2.77,0,0,1,1.25-2.16l2.65-1.53Z",
    transform: "translate(-29.74 -23.35)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M313.79,251.52l-1.64-1,1.9-4.52c.48-.84,1.27-1.3,1.76-1l1.87,1.08Z",
    transform: "translate(-29.74 -23.35)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M314,254.06v-2.67l3.44-2.87c.69-.39,1.25-.07,1.25.72v3.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M312.43,256.58l1.64-2.84,3,.48c.48.28.48,1.19,0,2l-1.88,3.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M310.35,257.68l2.31-1.34.76,3.53a2.74,2.74,0,0,1-1.25,2.16l-2.64,1.53Z",
    transform: "translate(-29.74 -23.35)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M308.93,256.72l1.64.94-1.89,4.52c-.49.85-1.28,1.3-1.77,1L305,262.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M309,254.26v2.67l-3.44,2.86c-.68.4-1.24.08-1.24-.72V256Z",
    transform: "translate(-29.74 -23.35)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M310.56,251.74l-1.64,2.83-3-.47c-.49-.28-.49-1.19,0-2l1.87-3.24Z",
    transform: "translate(-29.74 -23.35)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M315,252.15a7.58,7.58,0,0,1-3.43,5.94c-1.9,1.09-3.43.21-3.43-2a7.55,7.55,0,0,1,3.43-5.94C313.41,249.07,315,250,315,252.15Z",
    transform: "translate(-29.74 -23.35)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M314.36,252.49a6.28,6.28,0,0,1-2.84,4.92,1.79,1.79,0,0,1-2.38-.12,1.94,1.94,0,0,0,2.09-.15,6.25,6.25,0,0,0,2.84-4.91,2.32,2.32,0,0,0-.46-1.52A2,2,0,0,1,314.36,252.49Z",
    transform: "translate(-29.74 -23.35)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M314.07,252.23a6.25,6.25,0,0,1-2.84,4.91,1.94,1.94,0,0,1-2.09.15,2.35,2.35,0,0,1-.46-1.52,6.28,6.28,0,0,1,2.84-4.92,1.92,1.92,0,0,1,2.09-.14A2.32,2.32,0,0,1,314.07,252.23Z",
    transform: "translate(-29.74 -23.35)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M312.43,253.87l.33-.59-.57-.32h0a.66.66,0,0,0-.67.06,2.1,2.1,0,0,0-.95,1.65.71.71,0,0,0,.23.58h0l.67.39.37-.68A2.2,2.2,0,0,0,312.43,253.87Z",
    transform: "translate(-29.74 -23.35)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M313.06,253.91a2.11,2.11,0,0,1-.95,1.64c-.53.31-.95.06-.95-.55a2.08,2.08,0,0,1,.95-1.64C312.63,253.06,313.06,253.3,313.06,253.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.59 228.86 274.44 241.47 272.48 230.12 250.63 217.51 252.59 228.86"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "248.6 228.1 244.2 225.58 251.06 213.7 255.46 216.21 248.6 228.1"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "255.46 216.21 257.48 217.4 255.87 220.57 257.49 231.72 248.6 228.1 255.46 216.21"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "255.29 231.96 250.89 229.44 257.75 217.56 262.15 220.07 255.29 231.96"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "262.15 220.07 264.17 221.26 262.56 224.43 264.18 235.58 255.29 231.96 262.15 220.07"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "261.95 235.77 257.55 233.25 264.42 221.37 268.81 223.88 261.95 235.77"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "268.81 223.88 270.83 225.08 269.22 228.24 270.84 239.4 261.95 235.77 268.81 223.88"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "265.21 225.81 266.7 226.67 263.4 232.39 261.92 231.52 265.21 225.81"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 288.34,
    y: 249.12,
    width: 6.6,
    height: 3.85,
    transform: "translate(-101.34 354.73) rotate(-60)"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "258.52 221.93 260 222.8 256.7 228.51 255.22 227.65 258.52 221.93"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 281.65,
    y: 245.25,
    width: 6.6,
    height: 3.85,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -101.33, 347.02)"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "251.8 218.05 253.28 218.92 249.99 224.63 248.5 223.77 251.8 218.05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 274.93,
    y: 241.37,
    width: 6.6,
    height: 3.85,
    transform: "translate(-101.34 339.22) rotate(-59.99)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M294.16,229.6l2.92-1.67a1.22,1.22,0,0,1,1.14-.05l-2.69-1.55h0a1.23,1.23,0,0,0-1.26,0L291.36,228v3l2.23-1.28.57.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.16,229.6v3l2.23-1.28,2,1.15.54-.31V229a1.24,1.24,0,0,0-1.85-1.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "264.42 209.2 261.62 207.58 261.62 204.63 264.42 206.25 264.42 209.2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M298.21,231.93l2.91-1.66a1.24,1.24,0,0,1,1.15-.05l-2.69-1.56h0a1.19,1.19,0,0,0-1.25,0l-2.92,1.67v2.94l2.23-1.28.58.34Z",
    transform: "translate(-29.74 -23.35)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.21,231.93v2.95l2.23-1.28,2,1.16.54-.31v-3.12a1.23,1.23,0,0,0-1.85-1.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "268.47 211.54 265.66 209.92 265.66 206.97 268.47 208.59 268.47 211.54"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M302.05,234.15l2.91-1.67a1.24,1.24,0,0,1,1.15,0l-2.69-1.56h0a1.23,1.23,0,0,0-1.26,0l-2.92,1.67v2.95l2.23-1.28.58.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.05,234.15v2.95l2.23-1.28,2,1.15.54-.31v-3.11a1.24,1.24,0,0,0-1.85-1.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "272.31 213.75 269.5 212.13 269.5 209.19 272.31 210.81 272.31 213.75"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M306,236.41l2.92-1.67a1.22,1.22,0,0,1,1.14-.05l-2.69-1.56h0a1.23,1.23,0,0,0-1.26,0l-2.91,1.67v2.94l2.23-1.27.57.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M306,236.41v2.94l2.23-1.27,2,1.15.54-.31v-3.11a1.23,1.23,0,0,0-1.85-1.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "276.21 216.01 273.41 214.39 273.41 211.44 276.21 213.06 276.21 216.01"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M309.8,238.63l2.92-1.67a1.19,1.19,0,0,1,1.14,0l-2.69-1.56h0a1.22,1.22,0,0,0-1.25,0L307,237v3l2.23-1.28.57.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.8,238.63v3L312,240.3l2,1.15.54-.31V238a1.24,1.24,0,0,0-1.85-1.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "280.06 218.23 277.26 216.61 277.26 213.67 280.06 215.29 280.06 218.23"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M287.56,230v2h0a1.23,1.23,0,0,0,.72,1,3.88,3.88,0,0,0,3.51,0,1.23,1.23,0,0,0,.72-1v-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-77",
    cx: 260.29,
    cy: 206.67,
    rx: 2.48,
    ry: 1.43
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M292,232.6v2h0a1.24,1.24,0,0,0,.73,1,3.86,3.86,0,0,0,3.5,0,1.23,1.23,0,0,0,.72-1v-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M296.26,233.61a3.92,3.92,0,0,1-3.5,0,1.07,1.07,0,0,1,0-2,3.92,3.92,0,0,1,3.5,0A1.07,1.07,0,0,1,296.26,233.61Z",
    transform: "translate(-29.74 -23.35)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M296.55,235.2v2h0a1.22,1.22,0,0,0,.73,1,3.86,3.86,0,0,0,3.5,0,1.23,1.23,0,0,0,.72-1v-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M300.78,236.21a3.86,3.86,0,0,1-3.5,0,1.06,1.06,0,0,1,0-2,3.86,3.86,0,0,1,3.5,0A1.07,1.07,0,0,1,300.78,236.21Z",
    transform: "translate(-29.74 -23.35)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M301.07,237.81v2h0a1.24,1.24,0,0,0,.72,1,3.86,3.86,0,0,0,3.5,0,1.23,1.23,0,0,0,.73-1v-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M305.29,238.82a3.86,3.86,0,0,1-3.5,0,1.06,1.06,0,0,1,0-2,3.86,3.86,0,0,1,3.5,0A1.06,1.06,0,0,1,305.29,238.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M305.62,240.44v2h0a1.24,1.24,0,0,0,.72,1,3.92,3.92,0,0,0,3.5,0,1.23,1.23,0,0,0,.73-1v-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-77",
    cx: 278.35,
    cy: 217.09,
    rx: 2.48,
    ry: 1.43
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M287.69,230.31l-2.77,1.61a3.67,3.67,0,0,0-1.66,2.87v3.32l2.8,1.62,1-4.71,3.39-3.09Z",
    transform: "translate(-29.74 -23.35)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.49,231.93l-2.77,1.61a3.66,3.66,0,0,0-1.66,2.87v3.32l2-1.14v-1.07a2.22,2.22,0,0,1,1.11-1.92l1.27-.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M291.54,232.53l-2.76,1.61a3.68,3.68,0,0,0-1.67,2.88v3.32l2.81,1.61,1-4.7,3.39-3.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.34,234.15l-2.76,1.61a3.67,3.67,0,0,0-1.66,2.88V242l2-1.14v-1.06a2.23,2.23,0,0,1,1.11-1.92l1.28-.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M295.39,234.75l-2.77,1.61a3.67,3.67,0,0,0-1.66,2.88v3.32l2.8,1.61,1-4.7,3.39-3.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.19,236.37,295.42,238a3.7,3.7,0,0,0-1.66,2.88v3.31l2-1.14V242a2.21,2.21,0,0,1,1.11-1.92l1.27-.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M299.31,237l-2.76,1.61a3.68,3.68,0,0,0-1.67,2.87v3.32l2.81,1.62,1-4.71,3.39-3.09Z",
    transform: "translate(-29.74 -23.35)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.11,238.64l-2.76,1.61a3.65,3.65,0,0,0-1.66,2.87v3.32l2-1.14v-1.07a2.24,2.24,0,0,1,1.11-1.92l1.28-.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M303.16,239.24l-2.76,1.61a3.67,3.67,0,0,0-1.66,2.88v3.32l2.8,1.61,1-4.7,3.39-3.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M306,240.86l-2.77,1.61a3.67,3.67,0,0,0-1.66,2.88v3.31l2-1.14v-1.06a2.21,2.21,0,0,1,1.11-1.92l1.27-.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M295.58,242.38v-6.14h-4.09c-.23-.15-.46-.31-.71-.45-6.41-3.7-16.8-3.7-23.21,0-.25.14-.48.3-.71.45h-4.1v6.25h0c0,2.42,1.6,4.85,4.81,6.7,6.41,3.7,16.8,3.7,23.21,0C294,247.31,295.63,244.84,295.58,242.38Z",
    transform: "translate(-29.74 -23.35)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-78",
    cx: 249.43,
    cy: 213.13,
    rx: 16.41,
    ry: 9.48
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 249.43,
    cy: 212.64,
    rx: 12.76,
    ry: 7.36
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "311.8 225.58 311.8 218.24 317.67 214.86 317.67 222.19 311.8 225.58"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "311.8 225.58 301.68 219.74 301.68 212.4 311.8 218.24 311.8 225.58"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "311.8 218.24 301.68 212.4 307.55 209.01 317.67 214.86 311.8 218.24"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M341.92,237v1.48h0a.9.9,0,0,0,.53.75,2.84,2.84,0,0,0,2.6,0,.92.92,0,0,0,.54-.75V237Z",
    transform: "translate(-29.74 -23.35)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M345.05,237.78a2.9,2.9,0,0,1-2.6,0,.79.79,0,0,1,0-1.5,2.84,2.84,0,0,1,2.6,0C345.77,236.69,345.77,237.36,345.05,237.78Z",
    transform: "translate(-29.74 -23.35)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.88,237.69l-24.23-41.85L148.77,163l-19.53,16.37L91.9,164v30.29l18.27,10.55c0-10.58,7.42-14.86,16.58-9.57s16.59,18.14,16.59,28.72l90.51,52.26c0-10.58,7.42-14.87,16.58-9.58S267,284.82,267,295.4l17.53,10.12.22-26.72Zm-53.35-31.25L138,184.2l15.65-14.55,22.87,13.25Zm3.26,1.87V184.72l24.84,14.37,19.5,34.84Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "57.75 170.63 71.35 178.51 71.35 170.58 57.75 162.71 57.75 170.63"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "74.22 168.92 62.17 161.97 62.16 160.27 57.75 162.71 71.35 170.58 74.22 168.92"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "74.22 176.85 71.35 178.51 71.35 170.58 74.22 168.92 74.22 176.85"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.79 181.53 146.79 183.09 108.27 160.85 123.92 146.31 124.42 146.59 109.82 160.17 146.79 181.53"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "146.79 159.56 146.79 181.53 109.82 160.17 124.42 146.59 146.79 159.56"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "194.39 210.58 150.05 184.97 150.05 161.38 151.6 162.28 151.6 184.28 193.08 208.24 194.39 210.58"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "193.08 208.24 151.6 184.28 151.6 162.28 174.89 175.74 193.08 208.24"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M145.5,195l-6-3.47a3.24,3.24,0,0,1-1.48-2.55v0c0-1,.66-1.33,1.48-.86l6,3.47a3.26,3.26,0,0,1,1.47,2.55v0C147,195,146.31,195.42,145.5,195Z",
    transform: "translate(-29.74 -23.35)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M190.1,220.7l-6-3.46a3.28,3.28,0,0,1-1.48-2.56v0c0-.94.66-1.33,1.48-.86l6,3.47a3.26,3.26,0,0,1,1.47,2.55v0C191.57,220.79,190.91,221.17,190.1,220.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229,271.36l-51.41-29.68V181.32l28,16.17L229,238.58Zm-50.5-30.2,49.59,28.64v-31L205,198.14l-26.43-15.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.54,242.2l-32.87-19V223c0-.14-.15-14.42-11.64-23.58l-.17-.14V199c0-1.58,0-15.5,0-15.5v-.2l18.32-16.7.29.16,26,15Zm-32-19.5,31.07,17.94V182.36l-25.31-14.61-17.54,16c0,1.64,0,12.91,0,15.08C145.56,207.56,146.48,220.68,146.56,222.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "309.46 216.42 272.79 237.6 267.65 234.63 304.34 213.46 309.46 216.42"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "272.79 259.63 267.65 256.67 267.65 234.63 272.79 237.6 272.79 259.63"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "309.46 238.46 272.79 259.63 272.79 237.6 309.46 216.42 309.46 238.46"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "307.17 238.4 275.21 256.85 275.21 237.65 307.17 219.2 307.17 238.4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M327.83,238.8v2.8h0a1.72,1.72,0,0,0,1,1.41,5.42,5.42,0,0,0,4.9,0,1.72,1.72,0,0,0,1-1.41v-2.8Z",
    transform: "translate(-29.74 -23.35)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M333.75,240.21a5.36,5.36,0,0,1-4.9,0c-1.36-.78-1.36-2.05,0-2.83a5.42,5.42,0,0,1,4.9,0C335.11,238.16,335.11,239.43,333.75,240.21Z",
    transform: "translate(-29.74 -23.35)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.8,195.59l-72.92,42.1,54.9,41.11,72.92-42.1Zm-67,43.44L301.69,201l49,36.71-65.88,38.05Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.36 212.96 320.96 214.35 271.95 177.63 206.05 215.68 203.66 213.88 271.95 174.46 323.36 212.96"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.57,153.74l-72.92,42.1,24.23,41.85,72.92-42.1ZM209,196.47l69-39.81,22,37.78-69,39.81Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.83 130.39 175.91 172.49 119.03 139.65 191.95 97.55 248.83 130.39"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "327.74 240.07 254.81 282.17 255.04 255.46 327.96 213.36 327.74 240.07"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "276.06 257.3 261.2 265.94 261.2 255.14 276.06 246.51 276.06 257.3"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "322.11 230.77 307.25 239.4 307.25 228.61 322.11 219.98 322.11 230.77"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.39 243.37 280.4 256.73 280.4 242.45 303.39 229.09 303.39 243.37"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "257.86 267.87 261.2 265.94 261.2 255.14 257.86 257.07 257.86 267.87"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "322.11 230.77 325.45 228.84 325.45 218.04 322.11 219.98 322.11 230.77"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.72,235.62a2.25,2.25,0,0,0-1-1.78.72.72,0,0,0-.75-.06L221,235.49l1.41,2.53,3-1.73h0A.74.74,0,0,0,225.72,235.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M222.74,237.36c0,.66-.46.92-1,.6a2.28,2.28,0,0,1-1-1.78c0-.66.46-.92,1-.6A2.28,2.28,0,0,1,222.74,237.36Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "193.07 206.27 181.93 212.72 179.98 211.6 191.12 205.14 193.07 206.27"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "181.93 221.62 179.98 220.49 179.98 211.6 181.93 212.72 181.93 221.62"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.07 215.16 181.93 221.62 181.93 212.72 193.07 206.27 193.07 215.16"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "262.79 164.74 257.48 167.8 255.93 165.22 237.49 175.81 237.49 179.34 196.62 203 201.22 210.91 270.19 171.09 262.79 164.74"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "270.19 171.09 201.22 210.91 200.7 210.02 268.69 170.77 247.24 133.87 248.21 133.31 270.19 171.09"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "206.09 206.91 203.66 159.03 218.88 150.24 222.78 197.28 206.09 206.91"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "237.92 188.58 236.18 140.25 242.04 136.94 245.9 183.93 237.92 188.58"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "161.23 189.84 153.45 163.34 160.25 167.28 168.99 194.33 161.23 189.84"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "175 197.8 165.84 170.51 169.06 172.37 181.71 201.63 175 197.8"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "128.31 170.84 124.95 146.97 127.88 148.7 132.68 173.37 128.31 170.84"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "136.26 175.39 132.39 151.22 140.03 155.61 144.83 180.28 136.26 175.39"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1,237a.72.72,0,0,1-.71-.69l-.82-42.8a.7.7,0,0,1,.69-.72.65.65,0,0,1,.72.69l.82,42.8a.7.7,0,0,1-.69.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.06 208.28 256.2 209.17 324.48 169.73 323.36 168.86 255.06 208.28"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.78 214.75 256.2 209.17 255.08 208.3 203.68 213.9 204.78 214.75"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.66 213.88 255.08 208.3 323.36 168.86 271.95 174.46 203.66 213.88"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "332.68 238.2 253.71 283.79 253.71 275.86 332.68 230.27 332.68 238.2"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "240.12 275.91 253.71 283.79 253.71 275.86 240.12 267.99 240.12 275.91"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "332.68 230.27 327.83 227.47 327.81 231.15 254.89 273.25 254.88 273.25 243 266.36 240.12 267.99 253.71 275.86 332.68 230.27"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.63 252.99 282.38 265.84 282.38 260.71 304.63 247.86 304.63 252.99"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "268.69 170.77 200.7 210.02 179.23 173.13 247.24 133.87 268.69 170.77"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M89.34,210.66c-1.57-.81-3.08.81-2.53,1.9a18.29,18.29,0,0,0,3.17,4.9c.26.44,1.84,2.59,2.66,2.62,1.12,0,2.76.16,2.91-.68A9.27,9.27,0,0,0,94.8,215C93.79,213.5,89.65,210.83,89.34,210.66Z",
    transform: "translate(-29.74 -23.35)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M85.11,190.45c-3.42,1.07-4.1-5.95-4.17,5.91,0,5.46,4.3,13.5,5.87,16.2a4.56,4.56,0,0,1,2.53-1.9c-.86-2.61-.48-10.21-2.48-14.7C87.21,189.17,86.72,191.19,85.11,190.45Z",
    transform: "translate(-29.74 -23.35)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M87.94,173.74c-7.88-.71-7,16.33-7.53,17.33-.16,2.16,6.83,3.87,7.88,1.67,1.06-4.89,1.17-5.47,2-10.22C91,177.11,90.52,174.06,87.94,173.74Z",
    transform: "translate(-29.74 -23.35)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.67,234.2c-.46-.64-6.5-2.08-6.5-2.08s-1.18,2.93-.76,4c.76,1.88,5.32,2.84,5.32,2.84s4.69,5,7.65,4.29c1-.46,1.33-1.45.63-3.14C81.87,237.16,78.38,236.59,76.67,234.2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.7,225.18c.2-.76-3.66-6.48-3.66-6.48s-2.48,0-3,1c-.94,1.8.57,6.25.57,6.25s.94,5.11,3.57,6.95c1.12.94,4.09.84,4.91-.79C40,230.09,36.21,227.13,36.7,225.18Z",
    transform: "translate(-29.74 -23.35)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64,196c4.42,2.35,10.2,20.14,10.57,20.58-1.36,5.23-4.65,11.17-5.55,15.69,1.06,3.86,8.56,3.55,8.63,1.35,1.27-3.34,5-8.71,6-17,.45-2.34-4.06-20.78-6.84-25.82C76.63,188.64,63.8,194.45,64,196Z",
    transform: "translate(-29.74 -23.35)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.21,176.25s-1.87,4.76-1.8,4.88,0,4.65,0,4.65l3.94.86,1.3-.84a8,8,0,0,0,2.68-.88A36.44,36.44,0,0,0,90.14,180l-3.84-5.1Z",
    transform: "translate(-29.74 -23.35)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M79.79,172.18c-3.94.39-8.16,3.2-8.16,3.2l-2.3.46-4.79,2.76a9,9,0,0,0-3.88,5.51,11.49,11.49,0,0,0,.34,7l13,1.53s10-3.71,11.6-6.81c-2,.56-3.37-.23-3.78-2-.73-3.28,2.8-7,2.8-7l2-2.89.5-2S82.76,171.88,79.79,172.18Z",
    transform: "translate(-29.74 -23.35)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.77,172.76c-8.86-1-11.37,3.91-20,7.06-1.64.38-2.23,1.57-1.36,1.38,8.14-1.91,13.17-8.63,21.35-7.12C85.48,173.56,86.08,173,84.77,172.76Z",
    transform: "translate(-29.74 -23.35)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.29,190.3,72.76,194s11.67-1,15.38-9c0,0-4,3.2-11.89,4.66C74.79,191.15,71.29,190.3,71.29,190.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.28,189.35a12.39,12.39,0,0,1-6.85.37c-3.54,0-5.67-4.06-4.27-6.43,2.78-4.69,9.47-7.91,9.47-7.91s-3.41-.78-7.91,2.45C59.29,179.66,56,182,54,187.66c-.6,2.16-6.42,19-7.49,21.78-7.7,2.14-10.07,5.4-13.9,9.17-.62,2.93,1.38,7.36,4,7,3.09-4,14.26-7.89,15.87-10.89,2.24-4.21,10-13.51,11.52-17.84a20.46,20.46,0,0,0,10.29-4.42S73.4,192.38,73.28,189.35Z",
    transform: "translate(-29.74 -23.35)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.26,171.84c-.44-.33-4-1.61-4-1.61H87.6l-3.25,2a32.93,32.93,0,0,0-.18,5.18c-.1,2.8,1.39,3.42,1.39,3.42a2.84,2.84,0,0,0,.32,2.05c.59.74,4.24,4.18,5.42,4.06a4.12,4.12,0,0,0,2.17-1.05c.59-.65,2.59-6.47,2.59-6.47A6.91,6.91,0,0,0,94.26,171.84Z",
    transform: "translate(-29.74 -23.35)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M85.82,169.87c-5.48,4.28-1.61,8.56-1.61,8.56s-.26-2.49.85-1.33a17.89,17.89,0,0,1,1.44,2.34c.39.64.85,1.25,1.1,1s1.91-2,1.62-2.95-1.86-2.34-.73-3.6,4.53,3.46,6.59,1.72C97.67,173.24,91.59,165.37,85.82,169.87Z",
    transform: "translate(-29.74 -23.35)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M100.35,248.59c0,9.11-6.39,12.8-14.28,8.25S71.79,241.21,71.79,232.1s6.39-12.8,14.28-8.24S100.35,239.48,100.35,248.59Z",
    transform: "translate(-29.74 -23.35)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M113.39,241.06c0-9.1-6.4-20.18-14.29-24.73-3.85-2.23-7.34-2.48-9.91-1.1h0l-13.13,7.58c2.58-1.44,6.11-1.21,10,1.05,7.89,4.55,14.28,15.62,14.28,24.73,0,4.37-1.47,7.48-3.86,9h0l13-7.52h0C111.91,248.56,113.39,245.44,113.39,241.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M100.94,248.25c0-9.11-6.39-20.19-14.28-24.74-3.85-2.22-7.35-2.48-9.91-1.1l-.69.4c2.58-1.44,6.11-1.21,10,1.05,7.89,4.55,14.28,15.62,14.28,24.73,0,4.37-1.47,7.48-3.86,9h0l.57-.33S101,255.07,100.94,248.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M105.2,245.8c0-9.1-6.39-20.18-14.28-24.73-3.85-2.23-7.35-2.48-9.91-1.1l-.69.4c2.58-1.44,6.11-1.21,10,1,7.89,4.56,14.28,15.63,14.28,24.74,0,4.36-1.47,7.48-3.86,9h0l.57-.34S105.21,252.62,105.2,245.8Z",
    transform: "translate(-29.74 -23.35)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M109.59,243.26c0-9.11-6.39-20.18-14.28-24.74-3.85-2.22-7.34-2.47-9.91-1.09l-.69.39c2.58-1.44,6.11-1.2,10,1.05C102.61,223.42,109,234.5,109,243.6c0,4.37-1.47,7.48-3.86,9.05h0l.57-.33S109.6,250.08,109.59,243.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M103.41,247.64l-1.9-3.08,1.11-3.26L100,238.82l.66-3.49-3.23-1.89.33-3.65L94,228.66l-.36-3.46-3.81-.54L89,222.15l-4.65-.52-1.45-1.32s-3.4.88-4.32,1.21a6.85,6.85,0,0,0-1,.43h0l-.56.31a7.43,7.43,0,0,1,1.48-.61l3.93-1.08,1.53,1.35,4.58.49.86,2.49,3.85.58.29,3.39L97.24,230,97,233.69l3.2,1.83-.67,3.42,2.64,2.47-1.09,3.3,1.89,2.95-1.79,2.77.89,1.95-2.39,2.44L99.29,256l.44-.25.17-.93,2.51-2.54-.84-1.95Z",
    transform: "translate(-29.74 -23.35)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M108,245l-1.9-3.08,1.11-3.26-2.63-2.48.65-3.49L102,230.78l.33-3.64L98.62,226l-.36-3.47L94.45,222l-.88-2.51L88.92,219l-1.46-1.32s-3.39.88-4.31,1.2a6.85,6.85,0,0,0-1,.43h0l-.56.32a6.33,6.33,0,0,1,1.47-.61c.83-.24,3.94-1.08,3.94-1.08l1.53,1.34,4.58.49.86,2.49,3.85.59.29,3.38,3.71,1.11-.28,3.71,3.2,1.83-.67,3.43,2.63,2.46-1.08,3.31,1.89,2.94-1.79,2.77.89,1.95-2.39,2.44-.34,1.21.44-.25.16-.93,2.52-2.54-.84-2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M112.55,242.35l-1.91-3.08,1.11-3.25-2.62-2.49.65-3.49-3.23-1.88.34-3.65-3.73-1.13-.35-3.46L99,219.37l-.88-2.51-4.65-.51L92,215s-3.39.88-4.32,1.2a7.28,7.28,0,0,0-1,.44h0l-.56.31a6.8,6.8,0,0,1,1.47-.61l3.94-1.08,1.53,1.35,4.58.48.86,2.5,3.85.58.28,3.39,3.72,1.11-.28,3.71,3.2,1.82-.67,3.43,2.63,2.47-1.08,3.3,1.89,2.94-1.79,2.78.88,1.94-2.39,2.44-.34,1.21.45-.25.16-.92,2.52-2.54-.84-1.95Z",
    transform: "translate(-29.74 -23.35)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M96.2,246.2c0,6.46-4.53,9.08-10.13,5.85S75.94,241,75.94,234.5s4.54-9.09,10.13-5.85S96.2,239.74,96.2,246.2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.92,245.46c0,5.64-4,7.92-8.85,5.1s-8.85-9.68-8.85-15.32,4-7.93,8.85-5.11S94.92,239.81,94.92,245.46Z",
    transform: "translate(-29.74 -23.35)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M89.2,242.15c0,2-1.4,2.81-3.13,1.81a6.91,6.91,0,0,1-3.13-5.42c0-2,1.4-2.81,3.13-1.81A6.92,6.92,0,0,1,89.2,242.15Z",
    transform: "translate(-29.74 -23.35)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M86.9,240.82c0,.53-.37.74-.83.48a1.82,1.82,0,0,1-.82-1.43c0-.53.37-.74.82-.48A1.84,1.84,0,0,1,86.9,240.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M88,240.06a.3.3,0,0,1-.15.21c-.23.13-.6-.08-.82-.48s-.23-.82,0-.95a.29.29,0,0,1,.16,0,1,1,0,0,0,.14.74A1,1,0,0,0,88,240.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M88,240.06a1,1,0,0,1-.67-.52,1,1,0,0,1-.14-.74.94.94,0,0,1,.66.52A1,1,0,0,1,88,240.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M88,243.26a.33.33,0,0,1-.15.21c-.23.13-.59-.08-.82-.47s-.23-.82,0-.95a.22.22,0,0,1,.16,0,1,1,0,0,0,.15.74A.88.88,0,0,0,88,243.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M88,243.26a.88.88,0,0,1-.66-.51,1,1,0,0,1-.15-.74.9.9,0,0,1,.66.51A1.08,1.08,0,0,1,88,243.26Z",
    transform: "translate(-29.74 -23.35)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M85.2,241.62a.3.3,0,0,1-.15.21c-.22.13-.59-.08-.82-.48s-.22-.82,0-.94a.32.32,0,0,1,.16,0,1,1,0,0,0,.15.73A.94.94,0,0,0,85.2,241.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M85.2,241.62a.94.94,0,0,1-.66-.52,1,1,0,0,1-.15-.73.91.91,0,0,1,.67.51A1,1,0,0,1,85.2,241.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M85.23,238.42a.32.32,0,0,1-.15.22c-.22.13-.59-.09-.82-.49s-.23-.82,0-1a.27.27,0,0,1,.16,0,1,1,0,0,0,.15.75A.89.89,0,0,0,85.23,238.42Z",
    transform: "translate(-29.74 -23.35)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M85.23,238.42a.89.89,0,0,1-.66-.51,1,1,0,0,1-.15-.75.91.91,0,0,1,.66.52A1,1,0,0,1,85.23,238.42Z",
    transform: "translate(-29.74 -23.35)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M88.76,233.58c-.55.73-1.55.85-2.69.19A7,7,0,0,1,83,229a6.76,6.76,0,0,1,.93.2,7,7,0,0,0,2.95,4A2.43,2.43,0,0,0,88.76,233.58Z",
    transform: "translate(-29.74 -23.35)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M89.17,232.57a2.26,2.26,0,0,1-.41,1,2.43,2.43,0,0,1-1.91-.36,7,7,0,0,1-2.95-4,9.32,9.32,0,0,1,2.17.94A14.66,14.66,0,0,1,89.17,232.57Z",
    transform: "translate(-29.74 -23.35)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M93,250.68a4.69,4.69,0,0,1-4.12,1c-.62-1.83-.31-3.48.84-3.9l.09,0a3.78,3.78,0,0,0-.16,3.38A5,5,0,0,0,93,250.68Z",
    transform: "translate(-29.74 -23.35)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M93.67,250a4.42,4.42,0,0,1-.65.71,5,5,0,0,1-3.35.43,3.78,3.78,0,0,1,.16-3.38C91,247.38,92.56,248.33,93.67,250Z",
    transform: "translate(-29.74 -23.35)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M94.92,245.45c0,.16,0,.31,0,.45a6.8,6.8,0,0,1-3.35-4.41c-.44-1.77,0-3.1,1.08-3.41a3.41,3.41,0,0,0-.31,2.86,7.26,7.26,0,0,0,2.58,3.95C94.91,245.08,94.92,245.27,94.92,245.45Z",
    transform: "translate(-29.74 -23.35)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M94.91,244.89a7.26,7.26,0,0,1-2.58-3.95,3.41,3.41,0,0,1,.31-2.86A2.2,2.2,0,0,1,93,238,17.83,17.83,0,0,1,94.91,244.89Z",
    transform: "translate(-29.74 -23.35)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M83.62,247.44a2.84,2.84,0,0,1-.31,1,20.88,20.88,0,0,1-4.81-7.21,1.89,1.89,0,0,1,1-.05A21.1,21.1,0,0,0,83.62,247.44Z",
    transform: "translate(-29.74 -23.35)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M83.62,247.44a21.1,21.1,0,0,1-4.14-6.24,5.14,5.14,0,0,1,3,2.37A6.33,6.33,0,0,1,83.62,247.44Z",
    transform: "translate(-29.74 -23.35)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M80.37,235.78c-.65.86-1.89.82-3.14-.09,0-.15,0-.3,0-.45A6.75,6.75,0,0,1,79.16,230l.12.15A7.51,7.51,0,0,0,78,234.69c0,.15,0,.29,0,.45A2.76,2.76,0,0,0,80.37,235.78Z",
    transform: "translate(-29.74 -23.35)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M80.67,235.2a2.26,2.26,0,0,1-.3.58,2.76,2.76,0,0,1-2.36-.64c0-.16,0-.3,0-.45a7.51,7.51,0,0,1,1.28-4.56C80.53,231.71,81.14,233.82,80.67,235.2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M79.15,217.38c-1.58-.81-4,.81-3.47,1.9.75,2.56,1.59,5,2.65,6.29a4.79,4.79,0,0,0,3.36,1.77c1.13,0,2.88-.12,3-1a19,19,0,0,0-1-4.81C83.08,219.93,79.46,217.55,79.15,217.38Z",
    transform: "translate(-29.74 -23.35)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M73.83,202.85c.35-6.79-.14-4.77-1.75-5.51-3.42,1.07-5.34-6.48-4.5,5.68,0,5.46,6.54,13.57,8.1,16.26.75,1.2,3.91-.78,3.47-1.9C77.56,214.67,76.53,207.69,73.83,202.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.58,181.43c-7.86.94-4.44,17.63-4.72,18.71.28,2.15,7.48,2.38,8,0,0-5,0-5.59-.17-10.41C76.47,184.5,74.16,181.2,71.58,181.43Z",
    transform: "translate(-29.74 -23.35)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.63,175.38c-.68.18-2.85,1-2.86,1.62,13,5.41,8.24,12.72,8.24,12.72l3-.79S84.13,181.69,71.63,175.38Z",
    transform: "translate(-29.74 -23.35)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 357.16,
    cy: 315,
    rx: 19.79,
    ry: 11.43,
    transform: "translate(-123.97 443.46) rotate(-60)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M330.39,315.7c0-8.92,6.27-19.77,14-24.24,3.78-2.18,7.2-2.42,9.72-1.07h0L367,297.82c-2.53-1.41-6-1.18-9.81,1-7.73,4.47-14,15.32-14,24.24,0,4.28,1.44,7.33,3.79,8.87h0l-12.76-7.37h0C331.84,323.05,330.39,320,330.39,315.7Z",
    transform: "translate(-29.74 -23.35)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M342.58,322.74c0-8.92,6.27-19.77,14-24.24,3.77-2.18,7.2-2.42,9.72-1.07l.67.39c-2.53-1.41-6-1.18-9.81,1-7.73,4.47-14,15.32-14,24.24,0,4.28,1.44,7.33,3.79,8.87h0l-.56-.33S342.58,329.43,342.58,322.74Z",
    transform: "translate(-29.74 -23.35)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M338.41,320.35c0-8.93,6.27-19.78,14-24.24,3.77-2.18,7.19-2.43,9.71-1.08l.67.39c-2.52-1.41-6-1.18-9.81,1-7.73,4.46-14,15.31-14,24.24,0,4.28,1.44,7.33,3.79,8.86h0l-.56-.33S338.4,327,338.41,320.35Z",
    transform: "translate(-29.74 -23.35)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M334.11,317.86c0-8.93,6.26-19.78,14-24.24,3.78-2.18,7.2-2.43,9.72-1.08l.67.39c-2.53-1.41-6-1.18-9.81,1-7.73,4.46-14,15.31-14,24.24,0,4.27,1.44,7.33,3.79,8.86h0l-.56-.32S334.1,324.54,334.11,317.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M340.16,322.15l1.87-3-1.09-3.19,2.57-2.44-.64-3.42,3.17-1.85-.33-3.57,3.65-1.11.35-3.39,3.73-.53.86-2.46,4.56-.5,1.43-1.3s3.32.86,4.23,1.18a6.5,6.5,0,0,1,1,.43h0l.55.31a7.38,7.38,0,0,0-1.45-.6l-3.86-1.05-1.49,1.31-4.49.48-.85,2.45-3.77.57-.28,3.32-3.64,1.08.28,3.64-3.14,1.79.66,3.36-2.59,2.42,1.07,3.23-1.86,2.89,1.75,2.72-.86,1.9,2.34,2.39.33,1.19-.43-.25-.16-.9-2.47-2.49.83-1.92Z",
    transform: "translate(-29.74 -23.35)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M335.66,319.54l1.87-3-1.09-3.19L339,310.9l-.64-3.42,3.16-1.85-.33-3.57,3.65-1.11.35-3.39L349,297l.86-2.46,4.56-.5,1.42-1.29s3.32.86,4.23,1.17a6.61,6.61,0,0,1,1,.43h0l.55.31a6.61,6.61,0,0,0-1.45-.6L356.25,293l-1.5,1.32-4.49.48-.84,2.44-3.78.57-.28,3.32-3.64,1.09.28,3.64-3.14,1.78.66,3.36-2.58,2.42,1.06,3.24-1.85,2.88,1.75,2.72-.87,1.91,2.35,2.39.33,1.18-.44-.24-.16-.91-2.46-2.48.82-1.92Z",
    transform: "translate(-29.74 -23.35)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M331.21,317l1.86-3L332,310.76l2.57-2.43-.64-3.42,3.16-1.85-.32-3.58,3.65-1.1.35-3.4,3.73-.53.86-2.46,4.56-.5,1.42-1.3s3.33.87,4.24,1.18a7,7,0,0,1,1,.43h0l.55.31a6.09,6.09,0,0,0-1.44-.6l-3.86-1.06-1.5,1.32-4.49.47-.84,2.45-3.77.57-.28,3.32-3.65,1.09.28,3.63-3.13,1.79.65,3.36-2.58,2.42,1.06,3.24L331.69,317l1.75,2.72-.86,1.91,2.34,2.39.33,1.18-.44-.24-.16-.91-2.46-2.49.82-1.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M347.23,320.74c0,6.33,4.44,8.9,9.93,5.73s9.93-10.87,9.93-17.2-4.45-8.9-9.93-5.73S347.23,314.4,347.23,320.74Z",
    transform: "translate(-29.74 -23.35)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.49,320c0,5.53,3.88,7.77,8.67,5s8.67-9.49,8.67-15-3.89-7.77-8.67-5S348.49,314.48,348.49,320Z",
    transform: "translate(-29.74 -23.35)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M354.09,316.77c0,2,1.37,2.75,3.07,1.78a6.79,6.79,0,0,0,3.06-5.32c0-2-1.37-2.75-3.06-1.77A6.77,6.77,0,0,0,354.09,316.77Z",
    transform: "translate(-29.74 -23.35)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M356.35,315.47c0,.52.36.73.81.47a1.82,1.82,0,0,0,.81-1.4c0-.52-.37-.73-.81-.47A1.78,1.78,0,0,0,356.35,315.47Z",
    transform: "translate(-29.74 -23.35)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M355.25,314.72a.32.32,0,0,0,.14.21c.23.13.59-.08.81-.47s.22-.8,0-.93a.29.29,0,0,0-.16,0,1,1,0,0,1-.14.73A.91.91,0,0,1,355.25,314.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M355.25,314.72a.91.91,0,0,0,.65-.5,1,1,0,0,0,.14-.73.93.93,0,0,0-.65.5A1,1,0,0,0,355.25,314.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M355.28,317.86a.34.34,0,0,0,.14.21c.22.13.58-.08.81-.47s.22-.8,0-.93a.29.29,0,0,0-.16,0,1.09,1.09,0,0,1-.14.73A.92.92,0,0,1,355.28,317.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M355.28,317.86a.92.92,0,0,0,.65-.5,1.09,1.09,0,0,0,.14-.73.92.92,0,0,0-.65.5A1,1,0,0,0,355.28,317.86Z",
    transform: "translate(-29.74 -23.35)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M358,316.25a.28.28,0,0,0,.15.2c.22.13.58-.07.8-.46s.22-.8,0-.93a.29.29,0,0,0-.16,0,1,1,0,0,1-.14.72A.93.93,0,0,1,358,316.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M358,316.25a.93.93,0,0,0,.65-.51,1,1,0,0,0,.14-.72.92.92,0,0,0-.65.51A1,1,0,0,0,358,316.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M358,313.12a.34.34,0,0,0,.14.21c.22.12.59-.09.81-.48s.23-.8,0-.93a.33.33,0,0,0-.17,0,1,1,0,0,1-.14.73A.93.93,0,0,1,358,313.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M358,313.12a.93.93,0,0,0,.65-.51,1,1,0,0,0,.14-.73.91.91,0,0,0-.64.51A1,1,0,0,0,358,313.12Z",
    transform: "translate(-29.74 -23.35)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M354.52,308.37c.54.71,1.52.84,2.63.19a6.89,6.89,0,0,0,3.05-4.69,6.63,6.63,0,0,0-.92.2A6.91,6.91,0,0,1,356.4,308,2.39,2.39,0,0,1,354.52,308.37Z",
    transform: "translate(-29.74 -23.35)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M354.12,307.38a2.22,2.22,0,0,0,.4,1,2.39,2.39,0,0,0,1.88-.35,6.91,6.91,0,0,0,2.88-3.95,9.59,9.59,0,0,0-2.13.92A14.6,14.6,0,0,0,354.12,307.38Z",
    transform: "translate(-29.74 -23.35)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M350.35,325.13a4.61,4.61,0,0,0,4,1c.61-1.8.3-3.41-.82-3.82l-.08,0a3.73,3.73,0,0,1,.15,3.31A4.9,4.9,0,0,1,350.35,325.13Z",
    transform: "translate(-29.74 -23.35)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M349.71,324.43a4.75,4.75,0,0,0,.64.7,4.9,4.9,0,0,0,3.28.42,3.73,3.73,0,0,0-.15-3.31C352.34,321.89,350.79,322.83,349.71,324.43Z",
    transform: "translate(-29.74 -23.35)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M348.49,320v.44a6.67,6.67,0,0,0,3.29-4.33c.43-1.73,0-3-1.06-3.34a3.34,3.34,0,0,1,.3,2.81,7.15,7.15,0,0,1-2.52,3.87C348.49,319.64,348.49,319.83,348.49,320Z",
    transform: "translate(-29.74 -23.35)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M348.5,319.46a7.15,7.15,0,0,0,2.52-3.87,3.34,3.34,0,0,0-.3-2.81l-.36-.06A17.37,17.37,0,0,0,348.5,319.46Z",
    transform: "translate(-29.74 -23.35)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M359.56,322a2.5,2.5,0,0,0,.3,1,20.33,20.33,0,0,0,4.72-7.06,1.82,1.82,0,0,0-1-.05A20.75,20.75,0,0,1,359.56,322Z",
    transform: "translate(-29.74 -23.35)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M359.56,322a20.75,20.75,0,0,0,4.06-6.12,5,5,0,0,0-2.95,2.32A6.19,6.19,0,0,0,359.56,322Z",
    transform: "translate(-29.74 -23.35)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M362.74,310.52c.64.85,1.85.82,3.08-.08,0-.15,0-.3,0-.44a6.58,6.58,0,0,0-1.9-5.15l-.12.14a7.33,7.33,0,0,1,1.26,4.47c0,.15,0,.29,0,.44A2.69,2.69,0,0,1,362.74,310.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M362.45,310a2.26,2.26,0,0,0,.29.56,2.69,2.69,0,0,0,2.32-.62c0-.15,0-.29,0-.44a7.33,7.33,0,0,0-1.26-4.47C362.59,306.54,362,308.61,362.45,310Z",
    transform: "translate(-29.74 -23.35)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.88,264.06c-.61,1.47-.16,5.29-1.45,7a3.05,3.05,0,0,1-1.95,1.09s.1,1.63-1.17,1.81-2-3-2-4.74,3.83-6.43,3.83-6.43S379.18,263.61,378.88,264.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M383.62,247.06a33.48,33.48,0,0,1,4.11,3.87c2.38,3-7.05,10.72-8.85,13.13-.94,1.18-2.9-.15-2.74-1.26,2.28-5.2,3.28-8,5.44-11.79A39.36,39.36,0,0,0,383.62,247.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.79,232.13c7.39,2.92-.26,17.4-.26,18.52-.83,2-8.09-.71-8-3.16a35.09,35.09,0,0,0,2.14-7.9C385.09,233.9,388.34,231.25,390.79,232.13Z",
    transform: "translate(-29.74 -23.35)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M397.84,229.22s3.48.42,3.48,1.15a6.9,6.9,0,0,0,1.07,3.56l-2.32,3.7-2.48,1.46h-2.85l-2-1.71,1.83-5.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M392.71,230.73l2.11,3s-1.28,2,.49,3c3.31,2.08,6.9-2.95,7.08-2.79a12.36,12.36,0,0,0,2.26,2l2.33,2.26,2.61,1.93s-.9,9-.82,10.25-6.34,7.84-5.24,12.1c.55,1-2.72,5.17-7.65,4.57.4-2.08-1.65-2.87-2.88-3.55a20.39,20.39,0,0,0-5.76-2.22s-2.81-14.78-2.29-19.87C385.33,235.44,392.71,230.73,392.71,230.73Z",
    transform: "translate(-29.74 -23.35)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M396.89,230.18c.66.16,2.19,1.37,2.19,1.95-10.07,2.22-10.72,10.66-10.72,10.66l-2.24-1.56A15.17,15.17,0,0,1,396.89,230.18Z",
    transform: "translate(-29.74 -23.35)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.37,247.68s-3,14.57-.45,18.27c.75,2.44-5.7,2.59-5.7,2.59l-5.05-4.32-1-4.15a60.12,60.12,0,0,1-.5-20.24C389.74,244.15,398.37,247.68,398.37,247.68Z",
    transform: "translate(-29.74 -23.35)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M404.65,236c.66.16,2.33,1.68,2.33,2.26-9.62,2.36-9.69,9.88-9.69,9.88l-2.8-1.1A14,14,0,0,1,404.65,236Z",
    transform: "translate(-29.74 -23.35)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M383.39,310.72c.46-.65,6.15.12,6.15.12s1.51,2.63.85,3.89c-.78,1.49-6,1.76-6,1.76s-4.74,4.05-7.71,3.33a2.23,2.23,0,0,1-.39-3.33C378.09,314.22,381.66,314,383.39,310.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M396,275.72c-2.36,2.19-11.8,19.16-11.36,20.5,2.1,4.6,3.63,7.2,5.44,14.27-.77,3.25-7.3,3.95-8.37,1.29-1.81-3.44-3.45-8.48-5.72-15.15-.45-2.36,4.67-22,9.45-31.55C385.6,263,396.13,274.46,396,275.72Z",
    transform: "translate(-29.74 -23.35)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M404.05,313.41l4.3-.75a9.64,9.64,0,0,1,.76,3.2c0,2.06-1.24,5.31-2.79,6.53s-4.35,1.44-5.15.18c-1.31-2,2.8-6.34,2.69-7.5A2.76,2.76,0,0,1,404.05,313.41Z",
    transform: "translate(-29.74 -23.35)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M397.92,266a6.66,6.66,0,0,0,5.61-3.44,24.8,24.8,0,0,1,3,5.54c.61,2.17,1.7,21.56,2.77,24.39a44.08,44.08,0,0,1,2,6.46c.51,2.16-.28,11.91-.62,15.37s-7,2.45-7.79-.11c.23-9,.69-15.76-.93-18.77-2.25-4.23-6.27-18.2-6.49-18.82-6.13-3.09-10.13-10.62-10.13-11.49a42.85,42.85,0,0,0,.81-5S394.64,266.11,397.92,266Z",
    transform: "translate(-29.74 -23.35)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M402.33,266c2.85-2.08,3.77-1.22,5.25-1.59,1.85.35,4.07,2.27,2.89,2.83-2.26,2-2.6,3.25-5.34,4.27-1.75.39-3.82,1-4.52.43-1-.71-2-2.08-1.61-2.89A18,18,0,0,1,402.33,266Z",
    transform: "translate(-29.74 -23.35)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M415.7,256.48c.07-.06-2.74-2.89-2.77-3.31-.1-1.67,2-4.57,3.79-4.75,2.91,2.13,5.85,5.45,6.33,7.45.91,3.74-9.95,9.94-12.58,11.38,0,0-.9-2.58-3.07-2.83C411.75,260.69,412.17,259,415.7,256.48Z",
    transform: "translate(-29.74 -23.35)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M391.84,221.74a14.7,14.7,0,0,1,2.5-.92H397l3.27,2,1.54,3.37a9.46,9.46,0,0,1,.09,3c-.29,2.68-2.24,2.83-2.24,2.83a3.59,3.59,0,0,1-.48,2.15c-.61.74-4.7,3.54-5.9,3.42a4.16,4.16,0,0,1-2.17-1.05c-.6-.66-1.48-7.51-1.48-7.51A7.14,7.14,0,0,1,391.84,221.74Z",
    transform: "translate(-29.74 -23.35)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M400.33,220.25c5.14,3.41,1.42,9.78,1.42,9.78s.16-3.21-1.5-1.8c-.53.56-.32.89-.72,1.55s-1.39,1-1.64.77a9.87,9.87,0,0,1-.23-4.1c.3-.95,1.94-1.7.81-3s-5.47,2.42-6.93,1C390.54,223.39,393.08,215.8,400.33,220.25Z",
    transform: "translate(-29.74 -23.35)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.59,251.08c1.09,1.88-5,6.49-6.92,4.95-3.2-3.15-3-3.37-6.27-6.76s-3.68-6.53-1.9-8.59C410.8,236.35,419.68,249.87,420.59,251.08Z",
    transform: "translate(-29.74 -23.35)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.9,322.75c.08.17.4.26.69.22s.38-.17.4-.31v2.43c0,.15-.16.27-.4.32a.7.7,0,0,1-.7-.22.3.3,0,0,1,0-.1v-2.43A.1.1,0,0,0,356.9,322.75Z",
    transform: "translate(-29.74 -23.35)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.27,322.35a.67.67,0,0,1,.69.22c.09.16-.08.35-.37.4s-.61-.05-.69-.22S357,322.4,357.27,322.35Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "367.6 304.26 366.34 304.99 365.27 300.95 366.52 300.22 367.6 304.26"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "366.34 304.99 365.46 304.48 363.51 300.43 365.27 300.95 366.34 304.99"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "351 303.74 349.04 305.54 347.8 306.26 349.74 304.47 351 303.74"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "349.74 304.47 347.8 306.26 346.91 305.75 347.98 302.95 349.74 304.47"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "357.22 310.26 355.96 310.98 354.89 306.94 356.14 306.22 357.22 310.26"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "355.96 310.98 355.07 310.47 353.13 306.42 354.89 306.94 355.96 310.98"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M380.61,320.21c1.16-.65,3,0,4.48,1.85,1.85,2.22,2.53,5.28,1.53,6.83a1.86,1.86,0,0,1-.63.62h0l-3.14,1.82a1.92,1.92,0,0,0,.59-.61c1-1.55.32-4.61-1.52-6.82-1.5-1.8-3.29-2.49-4.45-1.88l3.14-1.81Z",
    transform: "translate(-29.74 -23.35)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M391.72,313.8c1.15-.65,3,0,4.47,1.85,1.85,2.22,2.53,5.28,1.53,6.83a1.9,1.9,0,0,1-.63.63h0l-3.15,1.81h0a1.93,1.93,0,0,0,.61-.6c1-1.55.31-4.61-1.54-6.83-1.48-1.79-3.28-2.5-4.44-1.87l3.14-1.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.56,315.62c1.16-.66,3,0,4.48,1.85,1.85,2.22,2.53,5.28,1.53,6.83a1.86,1.86,0,0,1-.63.62L386,329.5a1.93,1.93,0,0,0,.61-.6c1-1.56.31-4.61-1.53-6.83-1.49-1.79-3.29-2.49-4.45-1.87l3.15-1.82Z",
    transform: "translate(-29.74 -23.35)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M381.92,323.9c1.84,2.21,2.53,5.27,1.52,6.82s-3.3,1-5.14-1.21-2.53-5.27-1.53-6.82S380.07,321.68,381.92,323.9Z",
    transform: "translate(-29.74 -23.35)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M377.93,323.36l-.05.06c-.76,1.19-.24,3.53,1.18,5.22,1.14,1.39,2.52,1.92,3.41,1.44-.79,1.11-2.52.68-3.9-1s-1.94-4-1.18-5.23A1.51,1.51,0,0,1,377.93,323.36Z",
    transform: "translate(-29.74 -23.35)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M377.93,323.36c.88-.48,2.26.05,3.41,1.43,1.41,1.69,1.93,4,1.16,5.22l0,.07c-.89.48-2.27-.05-3.41-1.44-1.42-1.69-1.94-4-1.18-5.22Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "366.47 291.28 363.72 292.86 363.72 290.14 366.47 288.56 366.47 291.28"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "366.47 288.56 363.72 290.14 360.52 288.29 363.27 286.71 366.47 288.56"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "363.72 292.86 360.52 291.01 360.52 288.29 363.72 290.14 363.72 292.86"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M391.94,313.75a.71.71,0,0,1,.17.71l-.08.07-1.42.81a.09.09,0,0,0,.06-.06.67.67,0,0,0-.15-.71c-.16-.18-.35-.25-.47-.19l1.43-.82C391.6,313.49,391.78,313.56,391.94,313.75Z",
    transform: "translate(-29.74 -23.35)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M390.52,314.57a.67.67,0,0,1,.15.71c-.1.16-.34.11-.53-.12a.67.67,0,0,1-.15-.71C390.08,314.29,390.33,314.34,390.52,314.57Z",
    transform: "translate(-29.74 -23.35)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M391.1,316.47a1.33,1.33,0,0,1-.78,1.09,4.15,4.15,0,0,1-3.79,0,1.32,1.32,0,0,1-.77-1.09v-2h5.34Z",
    transform: "translate(-29.74 -23.35)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M386.53,313.43a4.15,4.15,0,0,1,3.79,0,1.15,1.15,0,0,1,0,2.18,4.22,4.22,0,0,1-3.79,0A1.15,1.15,0,0,1,386.53,313.43Z",
    transform: "translate(-29.74 -23.35)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.88,313.62a3.43,3.43,0,0,1,3.09,0,.94.94,0,0,1,0,1.79,3.43,3.43,0,0,1-3.09,0A1,1,0,0,1,386.88,313.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.61,314.51h-2.18l1.54-.9A1.08,1.08,0,0,1,390.61,314.51Z",
    transform: "translate(-29.74 -23.35)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M386.86,315.43a3.54,3.54,0,0,0,3.14,0,1,1,0,0,0,0-1.82,3.47,3.47,0,0,0-3.14,0A1,1,0,0,0,386.86,315.43Zm.05-1.78a3.31,3.31,0,0,1,3,0c.85.48.85,1.26,0,1.74a3.31,3.31,0,0,1-3,0A.92.92,0,0,1,386.91,313.65Z",
    transform: "translate(-29.74 -23.35)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M388.57,314.5l1.92.28-1.94-.21a.24.24,0,0,1-.15,0c-.08,0-.13-.05-.11-.1a.14.14,0,0,1,.17-.06A.11.11,0,0,1,388.57,314.5Z",
    transform: "translate(-29.74 -23.35)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M388.5,314.53s-.05,0-.09,0-.06,0-.05-.05,0,0,.08,0S388.51,314.5,388.5,314.53Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "360.2 290.32 359.99 290.44 359.93 290.41 360.14 290.29 360.2 290.32"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 360.49,
    y: 291.16,
    width: 0.3,
    height: 0.02
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 358.67,
    y: 292.22,
    width: 0.03,
    height: 0.16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 356.58,
    y: 291.16,
    width: 0.29,
    height: 0.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 358.66,
    y: 289.95,
    width: 0.04,
    height: 0.16
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "359.52 290.06 359.41 290.21 359.38 290.19 359.49 290.05 359.52 290.06"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "357.98 290.2 357.96 290.21 357.84 290.06 357.87 290.05 357.98 290.2"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "356.98 290.79 356.97 290.81 356.71 290.76 356.73 290.73 356.98 290.79"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "357 291.56 356.74 291.62 356.73 291.6 356.99 291.54 357 291.56"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "358.04 292.15 357.94 292.3 357.91 292.3 358.01 292.15 358.04 292.15"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "359.49 292.29 359.47 292.29 359.35 292.14 359.39 292.14 359.49 292.29"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "360.64 291.6 360.63 291.62 360.36 291.56 360.37 291.54 360.64 291.6"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "360.66 290.75 360.38 290.81 360.38 290.78 360.64 290.72 360.66 290.75"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "360.21 292 360.14 292.05 359.93 291.92 360 291.88 360.21 292"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "357.46 291.92 357.24 292.06 357.17 292.01 357.39 291.89 357.46 291.92"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "357.43 290.42 357.36 290.45 357.16 290.33 357.23 290.3 357.43 290.42"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M382.74,313.34l9.52-5.49a1,1,0,0,1,1.57.91v1.77l-.84-.48v-1.29a.21.21,0,0,0-.31-.18l-9.51,5.49a1,1,0,0,0-.53.91,1,1,0,0,0,.53.9l2.09,1.21a3.66,3.66,0,0,0,3.65,0l9.67-5.59a1.07,1.07,0,0,1,1.59.91v5.07a1.93,1.93,0,0,1-1,1.67l-1.09.63a8.29,8.29,0,0,0-.19-.87l.87-.49a1.11,1.11,0,0,0,.53-.94v-5.07a.19.19,0,0,0-.1-.17.21.21,0,0,0-.22,0l-9.67,5.58a4.5,4.5,0,0,1-4.49,0l-2.1-1.21a1.89,1.89,0,0,1,0-3.27Z",
    transform: "translate(-29.74 -23.35)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M382.74,313.34l5.88-3.39a.2.2,0,0,1,.21,0,.66.66,0,0,1,.3.52.24.24,0,0,1-.08.19l-5.88,3.39a1,1,0,0,0-.53.91,1,1,0,0,0,.53.9l2.09,1.21a3.66,3.66,0,0,0,3.65,0l6-3.47h0a.2.2,0,0,1,.22,0,.69.69,0,0,1,.3.52.22.22,0,0,1-.09.19h0l-6,3.48a4.5,4.5,0,0,1-4.49,0l-2.1-1.21a1.89,1.89,0,0,1,0-3.27Z",
    transform: "translate(-29.74 -23.35)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M359.15,321a3.8,3.8,0,0,1,1.71,3.06v4.13a3,3,0,0,0,1.34,2.33L374,337.35a3,3,0,0,0,2.68,0l21.6-12.47c.36-.21.5-.43.5-.57s-.16-.27-.26-.33l-1.5-.86a2.46,2.46,0,0,0,.69-.68l1.26.76a1.28,1.28,0,0,1,.71,1.11,1.62,1.62,0,0,1-1,1.35l-21.6,12.47a3.86,3.86,0,0,1-3.58,0l-11.83-6.83a3.9,3.9,0,0,1-1.8-3.11v-4.13a3,3,0,0,0-1.25-2.28c-.41-.23-.7-.24-.78-.19s0,.09,0,.13v.94s0,.25-.45.25-.46-.25-.46-.25v-.94a1,1,0,0,1,.49-.91A1.68,1.68,0,0,1,359.15,321Z",
    transform: "translate(-29.74 -23.35)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M146.9,274.07a16.51,16.51,0,0,0-3.76-.43L142,277.43a7.65,7.65,0,0,0,2.73,1.35c1.21.18,3.1.15,3.53-1.35C149,274.74,147.55,274.44,146.9,274.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.27,317.72v11.42a3.82,3.82,0,0,0,2.16,3.21,12,12,0,0,0,10.88.35,3.82,3.82,0,0,0,2.35-3.07V318.2Z",
    transform: "translate(-29.74 -23.35)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.51,315a12,12,0,0,0-10.88-.35c-3.06,1.65-3.15,4.45-.2,6.29a12.06,12.06,0,0,0,10.88.33C128.38,319.64,128.46,316.82,125.51,315Z",
    transform: "translate(-29.74 -23.35)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M125.31,329.52a12,12,0,0,1-10.88-.35,3.83,3.83,0,0,1-2.15-3.2h0v1.78a3.84,3.84,0,0,0,2.16,3.2,12,12,0,0,0,10.88.35,3.8,3.8,0,0,0,2.35-3.07v-1.75A3.81,3.81,0,0,1,125.31,329.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M125.31,326.62a12,12,0,0,1-10.88-.35,3.83,3.83,0,0,1-2.15-3.21h0v1.79a3.85,3.85,0,0,0,2.16,3.21,12,12,0,0,0,10.88.34,3.81,3.81,0,0,0,2.35-3.07v-1.76A3.79,3.79,0,0,1,125.31,326.62Z",
    transform: "translate(-29.74 -23.35)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.51,316.61a5.49,5.49,0,0,0-5-.17c-1.4.75-1.45,2-.1,2.89a5.54,5.54,0,0,0,5,.15C123.83,318.73,123.86,317.44,122.51,316.61Z",
    transform: "translate(-29.74 -23.35)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.36,317.7a1.32,1.32,0,0,0,.74,1.08,4,4,0,0,0,3.67.12,1.27,1.27,0,0,0,.8-1v-2.4l-5.21-.16Z",
    transform: "translate(-29.74 -23.35)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.85,314.39a4.1,4.1,0,0,0-3.69-.12,1.13,1.13,0,0,0-.06,2.14,4.09,4.09,0,0,0,3.67.11A1.13,1.13,0,0,0,121.85,314.39Z",
    transform: "translate(-29.74 -23.35)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M120.83,314.93a1.9,1.9,0,0,0-1.69-.05c-.48.25-.49.69,0,1a1.9,1.9,0,0,0,1.69.05C121.28,315.65,121.29,315.22,120.83,314.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.67,258.94a.72.72,0,0,0-.61.82c0,.11,1.59,11.52-4.42,18.46-3.08,3.56-7.67,5.36-13.61,5.36-3.45,0-5.31-2.53-7.27-5.22-2.35-3.2-5-6.84-10.72-5.28-8.1,2.21-34.79,19.62-34.79,42,0,.39.32.55.72.55s.73-.16.73-.55c0-11.69,7.61-21.46,14-27.59,7.62-7.33,16.12-12,19.73-13,4.74-1.29,6.79,1.5,9.15,4.74,2.1,2.86,4.26,5.81,8.45,5.81,6.4,0,11.35-2,14.71-5.87,6.44-7.44,4.83-19.12,4.75-19.61A.71.71,0,0,0,190.67,258.94Z",
    transform: "translate(-29.74 -23.35)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M134.44,327.55l-2.3,3.74c-2,3.44,8.22,6.82,9,2.64a10.38,10.38,0,0,1,.71-4.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.44,328.47c-.81.89-1.49,4.11-1.49,4.11s4.23,2.09,4.51,1.06a18.19,18.19,0,0,1,1.36-2.91l-1.73-2S135.24,327.58,134.44,328.47Z",
    transform: "translate(-29.74 -23.35)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M140.8,271.3l-5.44-4.22-3,3.68c-1.15,1.4.64,4.17,1.83,4.94,2.18,1.38,6.91,1.72,7.83,1.73s2.13-1.77,1.13-3.79A7.84,7.84,0,0,1,140.8,271.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144.94,254.58c-2.05,0-4.19,1.89-6.21,5.72-1.44,3.05-2.38,3.76-4.54,7.3-.29,2.33,5.4,5.92,7.12,4.35,0-.43,3.73-4.28,5.38-7.33C149.91,258.71,150.94,254.84,144.94,254.58Z",
    transform: "translate(-29.74 -23.35)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M160,259.83a26.53,26.53,0,0,0-4.52-4c-3.52-1.68-4.44-.21-5.86-.21-3,0-6.11.22-7.19,7.36-.85,5.61,1.55,9.36,2.35,14.5.53,3.33,1,4.62,1.26,6.14a10.56,10.56,0,0,0,9.06,8.64c6.61.87,8.89-4.28,8.89-4.28a35.07,35.07,0,0,1,.75-4.28c1.47-6.28,4.25-10.56,1.36-18.27A37.28,37.28,0,0,1,160,259.83Z",
    transform: "translate(-29.74 -23.35)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.18,292.21c-.05,11.73-.36,18.85.07,21.11-4.46,2-11.11,18-11.11,18,4-4.53,9,2.64,9,2.64a42.47,42.47,0,0,1,8.17-14.71c3-4.66,6-20.84,6-20.84S143.38,290.17,143.18,292.21Z",
    transform: "translate(-29.74 -23.35)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.53,317.4c-1.26-.61-4.75.41-5.9-.24s-7.38,1.84-7.38,1.84-1.68,5.17.48,5.95,10.86-1.94,12.63-3S190.79,318,189.53,317.4Z",
    transform: "translate(-29.74 -23.35)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M164,287.93a17.68,17.68,0,0,1-6.83.91c-6.38-.38-11.12-5.27-11.12-5.27-1.52,3.06-4.06,8.9-2.4,12,1.08,2,6,4.94,10.94,6.05,2.71.59,17.68-.14,23.84-1.41a49.63,49.63,0,0,0-3.62,18.48c.54,3,9.51,2.22,9.84-1.09-1.17-4.93,3.7-13.71,3.68-23.12C188.48,289.81,164,287.93,164,287.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M185.89,256.33c-1.73,2.54-7.49,8.57-8.37,11.33a38.92,38.92,0,0,0-4.88.13c-1.43.73.48,4.74,1.2,6.28a13.78,13.78,0,0,0,4.66-.56c5.21-1.24,7.39-11.31,9.84-14.45C188.34,259.06,188.75,255.48,185.89,256.33Z",
    transform: "translate(-29.74 -23.35)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M176.41,266.85c-.42.12-2.79-.51-6.22-1-5.05-.75-12.67-1.63-11.78,6,.36,1.79,2.89,3,7.19,3.49,3.37.24,5.51.91,10.32.83C178.2,275.59,178.48,267.1,176.41,266.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.29,255.6c.57-.56-1.67-1-2.17-.23-8,15.14,6.75,33.49,6.75,33.49h2.74S141.57,270.18,149.29,255.6Z",
    transform: "translate(-29.74 -23.35)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.36,262.24c-12.89-.27-16.28,21.33-16.28,21.33l.26,1.52,1.53.3s4-22.64,16.72-21.17C164.59,264.22,163.25,262.19,162.36,262.24Z",
    transform: "translate(-29.74 -23.35)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.82,240.06c-.12-.38-10,9.88-10,9.88a13.29,13.29,0,0,1-3.14,5.63A26.71,26.71,0,0,1,160,259.83a24.93,24.93,0,0,1,0-5.6s2.06.42,2.72,0c1.31-.84,2.23-7.24,2.23-7.24S166.12,241.47,162.82,240.06Z",
    transform: "translate(-29.74 -23.35)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.21,242.76c-.56-1,2.6-2.32,1.37-3.62-3.5-3.7-11.6.76-11.6,6.86,0,6.91,6.12,5.94,7.32,6s1.7-3,2.74-3.62,2.09.56,2.09.56,1.32-3.31.83-4.53S161.77,243.72,161.21,242.76Z",
    transform: "translate(-29.74 -23.35)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M137.94,333.3c.16-1.13-4.66-2.66-5.42-.45s-2.54,3.82-1.82,5.67,6.27,2,7,.89a4.24,4.24,0,0,0,.52-3.49A6.42,6.42,0,0,1,137.94,333.3Z",
    transform: "translate(-29.74 -23.35)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.64,260a.55.55,0,0,0,.31.44,1.68,1.68,0,0,0,1.53.05.53.53,0,0,0,.32-.43l0-10.43-2.17-.07Z",
    transform: "translate(-29.74 -23.35)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.53,249.14a1.66,1.66,0,0,0-1.53,0,.47.47,0,0,0,0,.88,1.75,1.75,0,0,0,1.53.05C191.92,249.79,192,249.4,191.53,249.14Z",
    transform: "translate(-29.74 -23.35)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.53,249.52l-3.82,2.18a1.31,1.31,0,0,0-1.73-.08c-1.53,1.21-1,2.49-2.09,4.71a3.54,3.54,0,0,1,2.45,2.73,40.3,40.3,0,0,0,3.94-2.64c1.07-.94.55-4.13.9-4.37C194.11,251.38,194.05,249.09,193.53,249.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.13,241.91,188,249.63l.63,1.16,14.14-7.71a.34.34,0,0,0,.15-.3,1,1,0,0,0-.44-.82A.35.35,0,0,0,202.13,241.91Z",
    transform: "translate(-29.74 -23.35)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M187.84,249.93a1.05,1.05,0,0,0,.44.83.29.29,0,0,0,.48-.25,1,1,0,0,0-.45-.83C188.06,249.52,187.85,249.63,187.84,249.93Z",
    transform: "translate(-29.74 -23.35)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M188,250a.72.72,0,0,0,.3.55c.17.1.31,0,.32-.17a.71.71,0,0,0-.29-.56C188.13,249.75,188,249.83,188,250Z",
    transform: "translate(-29.74 -23.35)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M188,250a.72.72,0,0,0,.3.55c.17.1.31,0,.32-.17a.71.71,0,0,0-.29-.56C188.13,249.75,188,249.83,188,250Z",
    transform: "translate(-29.74 -23.35)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.86,245.94a1,1,0,0,0-1-.13l-4.5,2.58,1.9,3.57,4.51-2.58a1,1,0,0,0,.45-.91A3.15,3.15,0,0,0,192.86,245.94Z",
    transform: "translate(-29.74 -23.35)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.35,248.52c-.77-.48-1.43-.13-1.46.78a3.21,3.21,0,0,0,1.36,2.53c.77.49,1.43.13,1.46-.78A3.17,3.17,0,0,0,188.35,248.52Z",
    transform: "translate(-29.74 -23.35)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.13,241.84a5.19,5.19,0,0,0-4.7.16l-.16.09-.82,0v4.36a1.63,1.63,0,0,0,1,1.36,5.21,5.21,0,0,0,4.71-.15,1.63,1.63,0,0,0,.93-1.39v-4.39l-.83,0Z",
    transform: "translate(-29.74 -23.35)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.09,240.63a5.21,5.21,0,0,0-4.71.14c-1.28.8-1.25,2,.09,2.73a5.18,5.18,0,0,0,4.71-.15C194.46,242.55,194.42,241.33,193.09,240.63Z",
    transform: "translate(-29.74 -23.35)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M164.84,247.85s-.29,1.42-.86,3.27a14.88,14.88,0,0,1-1.6,3.25,1.81,1.81,0,0,0,2,.21c1-.58,1.45-4,1.14-5.22S164.84,247.85,164.84,247.85Z",
    transform: "translate(-29.74 -23.35)"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "133.39 225.94 134.79 228.05 134.94 227.29 133.39 225.62 133.39 225.94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Page);
export default __webpack_public_path__ + "static/media/404page.bee477835831f5455657a756f1aa6138.svg";
export { ForwardRef as ReactComponent };